import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { CommonService } from '../../../shared/services/commen/commen.services';
import { Helpers } from '../../../helpers';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../../../_services/app.service';
import { environment } from '../../../../environments/environment';
import { PrintFormatsComponent } from '../../../print-formats/print-formats.component';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationPopupComponent } from '../confirmation-popup/confirmation-popup.component';
import { Router } from '@angular/router';
import { SendMailComponent } from '../send-mail/send-mail.component';
import { PrintFormatsNewComponent } from '../../../../app/print-formats-new/print-formats-new.component';
import { EwayBillLogComponent } from '../eway-bill-log/eway-bill-log.component';
import { EwayBillService } from '../../services/EwayBill/eway-bill.service';
import { ChangeTransVehDriverComponent } from '../change-trans-veh-driver/change-trans-veh-driver.component';
import { ExtendEwayBillComponent } from '../extend-eway-bill/extend-eway-bill.component';
import { OrdersService } from '../../services/orders/orders.service';
import { PrintReportComponent } from '../print-report/print-report.component';
import { error } from 'jquery';
import { DriverConsentComponent } from '../driver-consent/driver-consent.component';
import { SalesInvoiceFormComponent } from '../../../../app/Sales/sales-invoice-new/sales-invoice-form/sales-invoice-form.component';
import { PurchaseBillsFormComponent } from '../../../../app/Purchase/purchase-bills/purchase-bills-form/purchase-bills-form.component';

@Component({
  selector: 'app-common-dropdownlist',
  templateUrl: './common-dropdownlist.component.html',
  styleUrls: ['./common-dropdownlist.component.scss']
})
export class CommonDropdownlistComponent implements OnInit {

  @Input() type: any = '';
  @Input() data: any;
  @Input() cardIndex: number | null = null;
  @Output() itemSelected = new EventEmitter<any>();
  @Input() Title: any = '';
  @Input() IsShowIcon: any = false;
  @Input() SvgType: string = 'default';
  @Input() selectedIndex: number | null = null;
  @Output() dropdownOpened = new EventEmitter<number>();
  SelectedComapnyName: any;
  SelectedCompanyAdd: any;
  SelectedCompanyCIN: any;
  SelectedCompantGSTIN: any;
  SelectedCompanyLogo: any;
  SelectedCompanyPAN: any;
  SelectedCompanyLogoImg: any;
  SelectedCompanyGSTCode: any;
  hostUrl: any = environment.apiUrl;
  items: any[] = [];
  isOpen = false;
  openUpwards: boolean = false;
  @Input() TabContext: 'DETAILS' | 'TRIPS' | null = null;
  @Input() InvoiceId: any;
  CompanyId: any;
  userId: any;
  CancelReason: any = {
    lable: "Reason",
    formControlName: 'CancelReason',
    dataField: 'CancelReason',
    isValueBind: true,
    isSearchByApi: true,
    placeholder: "Select Reason",
    isRequired: true,
  };
  @Input() isFormPendingInvoicePage: any;
  ConsignmentNo: any = {
    lable: "",
    formControlName: 'ConsignmentNo',
    dataField: 'ConsignmentNo',
    isValueBind: true,
    isSearchByApi: true,
    placeholder: "Select Consignment No",
  };
  findLR: any = {};
  @Input() IsSubMenu: boolean = false;
  @ViewChild(PrintFormatsComponent) PrintFormatsChild: PrintFormatsComponent;
  @ViewChild(PrintFormatsNewComponent) PrintFormatsNewComponent: PrintFormatsNewComponent;
  isPrinting: boolean = true;
  @Input() ShowAction: boolean = false;
  @Input() filterObj: any = {};
  @Input() BillPaymentId: any;
  @Input() ReferenceId: any;
  //added by burhan - 11-Feb-2026
  @Input() CashExpenseId: any;
  //ended by burhan - 11-Feb-2026


  //added by fahim 31-12-2025
  modalRef: any;
  @ViewChild('content') contactFromTemplate: TemplateRef<any>;
  ModalTitle:any;
  ReasonFor:any;
  cancelType:any;
  selectedId:any;
  @Output() onRefreshList = new EventEmitter<any>();
  //End added by fahim 31-12-2025
  EwayBillFiling: boolean = false;
  BookingId: any;
  ConsignmentDetailId: any;
  OrderId: any;
  EwayConsignmentList: any = [];

  CustomerId: any;  //added by fahim 03-02-2026 :)
  @ViewChild("AddOrders") AddOrders: TemplateRef<any>; //added by fahim 03-02-2026 :)
  DriverMobileNo: any; // Added by priya - 02/04/2026 - cn(PRIYA-APR26-001)
  IsSimTracking: boolean = false; // Added by priya - 02/04/2026 - cn(PRIYA-APR26-001)
  IsFtlMarkedContainerPicked: boolean = false; // Added by priya - 27/07/2026 - cn(PRIYA-JUL26-016)

  constructor(
    private eRef: ElementRef,
    private commonService: CommonService,
    private _appService: appService,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private modalService: NgbModal,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private Eway: EwayBillService, // Added by priya - 09/02/2026 - Importing ewaybill service for common function - cn(PRIYA-JAN26-017)
    private orderService: OrdersService
  ) { }

  ngOnInit() {
    this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    // Added by priya - 28/01/2026 - getting eway bill system setting value from local storage - cn(PRIYA-JAN26-014)
    let ewayBillSystemSetting = localStorage.getItem("EwayBillFiling")
    this.EwayBillFiling = ewayBillSystemSetting == '1' ? true : false;
    // console.log('================================', this.type, this.data, this.InvoiceId, this.items)
    // Added by priya - 02/04/2026 - cn(PRIYA-APR26-001)
    let SimTrackingSystemSetting = localStorage.getItem("IsSimTracking")
    this.IsSimTracking = SimTrackingSystemSetting == '1' ? true : false;
    // Added by priya - 27/07/2026 - cn(PRIYA-JUL26-016)
    let FtlMarkedContainerPicked = localStorage.getItem("IsFtlMarkedContainerPicked")
    this.IsFtlMarkedContainerPicked = FtlMarkedContainerPicked == '1' ? true : false;
    this.loadItemsByType();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log('---------------------', changes['type'], changes['data'], changes['InvoiceId'], )
    if (changes['type'] || changes['data']) {
      if (changes['data'] && changes['data'].currentValue) {
        this.data = changes['data'].currentValue;

        // 🔥 Force Angular to detect internal changes
        this.data = Object.assign({}, this.data);

        this.loadItemsByType();
        if (this.type == 'SalesInvoice') {
          this.GetLoginCompanyData();
        }
        if (changes['InvoiceId'] && changes['InvoiceId'].currentValue) {
          this.InvoiceId = changes['InvoiceId'].currentValue;
          if (this.InvoiceId && this.type == 'SalesInvoice') {
            this.GetInvoiceById();
          }
          // if (this.InvoiceId && this.type == 'PaymentMade') {
          //   this.GetBillPaymentById();
          // }
          //added by BURHAN - 12-Feb-2026
          if (this.InvoiceId && this.type == 'CashExpense') {
            this.GetExpenseById();
          }
          if (this.InvoiceId && this.type == 'CashReceipt') {
            this.GetCashReceiptById();
          }
          // if (this.InvoiceId && this.type == 'PurchaseBill') {
          //   this.GetPurchaseBillById();
          // }
          //ended by BURHAN - 12-Feb-2026
        }
      }
    }
    // Added by priya - 29/12/2025
    // if (changes['BillPaymentId'] && changes['BillPaymentId'].currentValue) {
    //   this.BillPaymentId = changes['BillPaymentId'].currentValue;
    //   if (this.BillPaymentId) {
    //     this.GetBillPaymentById();
    //   }
    // }

    if (changes['TabContext']) {
      if (changes['TabContext'] && changes['TabContext'].currentValue) {
        this.loadItemsByType();
      }
    }

    if (this.selectedIndex !== this.cardIndex) {
      this.isOpen = false;
    }
  }

  loadItemsByType() {
    // console.log('data', this.data)
    switch (this.type) {
      case 'FtlList':
        this.items = [
          { label: 'Edit', visible: this.commonService.CheckHasRight('EDIT', 'FTL_DETAILS') },
          { label: 'View', visible: this.commonService.CheckHasRight('VIEW', 'FTL_DETAILS') },
          { label: 'Ship Now', visible: (this.data.OrderStatus === 'Pending' || this.data.OrderStatus === 'Partial') && this.commonService.CheckHasRight('SHIPNOW', 'FTL_DETAILS') },
          { label: 'Attachments', visible: this.commonService.CheckHasRight('ATTACHMENTS', 'FTL_DETAILS') },
          { label: 'Delete', visible: this.commonService.CheckHasRight('DELETE', 'FTL_DETAILS') },
          {
            label: 'Record Income',
            visible:
              this.commonService.CheckHasRight('RECORD_INCOME', 'FTL_DETAILS')
          },
          {
            label: 'Trip Expense',
            visible:
              (this.data.OrderStatus === 'Booked' || this.data.OrderStatus === 'Partial') &&
              this.commonService.CheckHasRight('TRIP_EXPENSE', 'FTL_DETAILS')
          },
          { label: 'Print Quote', visible: this.commonService.CheckHasRight('PRINTQUOTE', 'FTL_DETAILS') },
          { label: 'Mail Quote', visible: this.commonService.CheckHasRight('MAILQUOTE', 'FTL_DETAILS') },
          { label: 'Cancel Order', visible: (this.data.BookingCount === 0 || this.data.BookingCount === '0') && this.commonService.CheckHasRight('CANCELORDER', 'FTL_DETAILS') },
          // Added by priya - 10/01/2026 - print trip profibility - CN - PRIYA-JAN26-008
          { label: 'Print Trip Profitibilty', visible: true },
          // Added by priya - 31/01/2026 - print trip profibility - CN(PRIYA-JAN26-015)
          //added by BURHAN - 10/4/2026 - Copy & Create New option
          { label: 'Copy & Create New', visible: (window.location.pathname == '/FtlList') ? false : true, disabled: false },
          //end by BURHAN - 10/4/2026
          { label: 'Eway Bill Log', visible: this.EwayBillFiling },
          { label: 'Notes', visible: true}, // added by yash 23/04/2026
        ];
        break;
      case 'LTLList':
        this.items = [
          { label: 'Edit', visible: this.commonService.CheckHasRight('EDIT', 'FTL_DETAILS') },
          { label: 'View', visible: this.commonService.CheckHasRight('VIEW', 'FTL_DETAILS') },
          { label: 'Ship Now', visible: (this.data.OrderStatus === 'Pending' || this.data.OrderStatus === 'Partial') && this.commonService.CheckHasRight('SHIPNOW', 'FTL_DETAILS') },
          { label: 'Attachments', visible: this.commonService.CheckHasRight('ATTACHMENTS', 'FTL_DETAILS') },
          { label: 'Delete', visible: this.commonService.CheckHasRight('DELETE', 'FTL_DETAILS') },
          {
            label: 'Record Income',
            visible:
              this.commonService.CheckHasRight('RECORD_INCOME', 'FTL_DETAILS')
          },
          {
            label: 'Trip Expense',
            visible:
              (this.data.OrderStatus === 'Booked' || this.data.OrderStatus === 'Partial') &&
              this.commonService.CheckHasRight('TRIP_EXPENSE', 'FTL_DETAILS')
          },
          { label: 'Print Quote', visible: this.commonService.CheckHasRight('PRINTQUOTE', 'FTL_DETAILS') },
          { label: 'Cancel Order', visible: (this.data.BookingCount === 0 || this.data.BookingCount === '0') && this.commonService.CheckHasRight('CANCELORDER', 'FTL_DETAILS') },
          // Added by priya - 10/01/2026 - print trip profibility - CN - PRIYA-JAN26-008
          { label: 'Print Trip Profitibilty', visible: true },
          // Added by priya - 31/01/2026 - print trip profibility - CN(PRIYA-JAN26-015)
          { label: 'Eway Bill Log', visible: this.EwayBillFiling },
          { label: 'Notes', visible: true}, // added by yash 23/04/2026
        ];
        break;
      case 'FtlContainerList':
        this.items = [
          { label: 'Edit', visible: this.commonService.CheckHasRight('EDIT', 'FTLContainerMovement_DETAILS') },
          { label: 'View', visible: this.commonService.CheckHasRight('VIEW', 'FTLContainerMovement_DETAILS') },
          { label: 'Ship Now', visible: (this.data.OrderStatus === 'Pending' || this.data.OrderStatus === 'Partial') && this.commonService.CheckHasRight('SHIPNOW', 'FTLContainerMovement_DETAILS') },
          { label: 'Attachments', visible: this.commonService.CheckHasRight('ATTACHMENTS', 'FTLContainerMovement_DETAILS') },
          { label: 'Delete', visible: this.commonService.CheckHasRight('DELETE', 'FTLContainerMovement_DETAILS') },
          {
            label: 'Record Income',
            visible:
              this.commonService.CheckHasRight('RECORD_INCOME', 'FTLContainerMovement_DETAILS')
          },
          {
            label: 'Trip Expense',
            visible:
              (this.data.OrderStatus === 'Booked' || this.data.OrderStatus === 'Partial') &&
              this.commonService.CheckHasRight('TRIP_EXPENSE', 'FTLContainerMovement_DETAILS')
          },
          { label: 'Print Quote', visible: this.commonService.CheckHasRight('PRINTQUOTE', 'FTL_DETAILS') },
          { label: 'Cancel Order', visible: (this.data.BookingCount === 0 || this.data.BookingCount === '0') && this.commonService.CheckHasRight('CANCELORDER', 'FTL_DETAILS') },
          // Added by priya - 10/01/2026 - print trip profibility - CN - PRIYA-JAN26-008
          { label: 'Print Trip Profitibilty', visible: true },
          // Added by priya - 31/01/2026 - print trip profibility - CN(PRIYA-JAN26-015)
          { label: 'Eway Bill Log', visible: this.EwayBillFiling },
          { label: 'Notes', visible: true}, // added by yash 23/04/2026
        ];
        break;
        case 'FtlTripActions':
          this.items = [
            { label: 'Print Lorry Receipt', visible: this.commonService.CheckHasRight('PRINT_LR', 'FTL_DETAILS') },
            { label: 'Terms And Condition For LR', visible: this.commonService.CheckHasRight('PRINT_TermsAndConditionForLR', 'FTL_DETAILS') },
            { label: 'Print Alpha LR', visible: this.commonService.CheckHasRight('PRINT_ALPHA_LR', 'FTL_DETAILS') },//added by BURHAN - 3-March-2026
            { label: 'Mark As Container Picked', visible: this.IsFtlMarkedContainerPicked }, // Added by priya - 27/07/2026 - cn(PRIYA-JUL26-016)
            { label: 'Mark As Loaded', visible: this.commonService.CheckHasRight('MARK_LOADED', 'FTL_DETAILS') },
            { label: 'Mark As Delivered', visible: this.commonService.CheckHasRight('MARK_DELIVERED', 'FTL_DETAILS') },
            { label: 'Update Tracking Status', visible: this.commonService.CheckHasRight('UPDATE_TRACKING', 'FTL_DETAILS') },
            { label: 'Track', visible: this.commonService.CheckHasRight('TRACKING', 'FTL_DETAILS') },
            { label: 'Attachments', visible: this.commonService.CheckHasRight('TRIP_ATTACHMENTS', 'FTL_DETAILS') }, //added by BURHAN - 6-May-2026
            { label: 'Change Transporter, Driver & Vehicle', visible: this.commonService.CheckHasRight('CHANGE_TDV', 'FTL_DETAILS') },
            { label: 'Change History', visible: this.commonService.CheckHasRight('CHANGE_HISTORY', 'FTL_DETAILS') },
            { label: 'Record Income', visible: this.commonService.CheckHasRight('RECORD_INCOME', 'FTL_DETAILS') },
            { label: 'Trip Expense', visible: this.commonService.CheckHasRight('TRIP_EXPENSE', 'FTL_DETAILS') },
            { label: 'Cancel Booking', visible: this.commonService.CheckHasRight('CANCELBOOKING', 'FTL_DETAILS') },
            { label: 'Eway Bill Log', visible: this.EwayBillFiling },
            { label: 'Add Orders', visible: this.commonService.CheckHasRight('ADDORDERS', 'FTL_DETAILS') },  //Added by fahim 03-02-2026 :)
            { label: 'Check Driver Consent', visible: this.IsSimTracking }, // Added by priya - 02/04/2026 - cn(PRIYA-APR26-001)
            { label: 'Notes', visible: true}, // added by yash 23/04/2026
          ];
          break;
        case 'FtlContainerTripActions':
          this.items = [
            { label: 'Track', visible: this.commonService.CheckHasRight('TRACKING', 'FTLContainerMovement_DETAILS') },
            { label: 'Print Lorry Receipt', visible: this.commonService.CheckHasRight('PRINT_LR', 'FTLContainerMovement_DETAILS') },
            { label: 'Mark As Container Picked', visible: this.commonService.CheckHasRight('MARK_CONTPICK', 'FTLContainerMovement_DETAILS')  },
            { label: 'Mark As De-Stuffed', visible: this.commonService.CheckHasRight('MARK_LOADED', 'FTLContainerMovement_DETAILS')  },
            { label: 'Mark As Delivered', visible: this.commonService.CheckHasRight('MARK_DELIVERED', 'FTLContainerMovement_DETAILS') },
            { label: 'Update Tracking Status', visible: this.commonService.CheckHasRight('UPDATE_TRACKING', 'FTLContainerMovement_DETAILS') },
            { label: 'Change Transporter, Driver & Vehicle', visible: this.commonService.CheckHasRight('CHANGE_TDV', 'FTLContainerMovement_DETAILS')  },
            { label: 'Change History', visible: this.commonService.CheckHasRight('CHANGE_HISTORY', 'FTLContainerMovement_DETAILS') },
            { label: 'Record Income', visible: this.commonService.CheckHasRight('RECORD_INCOME', 'FTLContainerMovement_DETAILS') },
            { label: 'Trip Expense', visible: this.commonService.CheckHasRight('TRIP_EXPENSE', 'FTLContainerMovement_DETAILS') },
            { label: 'Cancel Booking', visible: this.commonService.CheckHasRight('CANCELBOOKING', 'FTLContainerMovement_DETAILS') },
            { label: 'Check Driver Consent', visible: this.IsSimTracking }, // Added by priya - 02/04/2026 - cn(PRIYA-APR26-001)
            { label: 'Notes', visible: true}, // added by yash 23/04/2026
          ];
          break;

      case 'country':
        this.items = [
          { label: 'USA', visible: true },
          { label: 'India', visible: true },
          { label: 'Germany', visible: true },
        ];
        break;
      case 'status':
        this.items = [
          { label: 'Active', visible: true },
          { label: 'Inactive', visible: true },
          { label: 'Pending', visible: true },
        ];
        break;
      //added by burhan - 11-Feb-2026
      case 'CashExpense': 
        this.items = [
          { label: 'Edit', visible: this.ShowAction, disabled: false },
          { label: 'View', visible: this.ShowAction, disabled: false },
          { label: 'Print Expense Voucher', visible: true, disabled: this.InvoiceId ? false : true },
          { label: 'Delete', visible: true, disabled: this.InvoiceId ? false : true },
          { label: 'Notes', visible: true, disabled: false}, // added by yash 07-05-2026
        ];
        break;
        //added 12-Feb-2026
      case 'CashReceipt':
        this.items = [
          { label: 'Edit', visible: this.ShowAction, disabled: false },
          { label: 'View', visible: this.ShowAction, disabled: false },
          { label: 'Delete', visible: true, disabled: this.InvoiceId ? false : true },
          { label: 'Notes', visible: true, disabled: false},  // added by yash 26-05-2026
        ];
        break;
        //added 10-March-2026
      case 'PendingInvoiceConsignment':
        this.items = [
          { label: 'View Trips', visible: this.ShowAction, disabled: false },
          { label: 'Generate Invoice', visible: this.ShowAction, disabled: false }
        ];
        break;
        //ended 10-March-2026
        //ended 12-Feb-2026
      //ended by burhan - 11-Feb-2026
        case 'SalesInvoice':
        this.items = [
          { label: 'Edit', visible: this.ShowAction, disabled: false },
          { label: 'View', visible: this.ShowAction, disabled: false },
          {
            label: 'E-Invoice',
            visible: true,
            isSubMenu: true,
            children: [
              { label: 'Send For E-Invoice', visible: true, action: 'SEND_E_INVOICE', isSubMenu: true, disabled: !this.InvoiceId || this.data && this.data.IsEInvoiceDone === true },
              {
                label: 'Cancel E-Invoice', visible: true, action: 'CANCEL_E_INVOICE', isSubMenu: true,
                disabled: !(
                  (this.data && this.data.IsEInvoiceDone) === true &&
                  (this.data && this.data.IsEInvoiceCancel === false) || (this.data && this.data.IsEInvoiceCancel) == null)
              },
            ]
          },
          {
            label: 'Print',
            visible: true,
            isSubMenu: true,
            children: [
              { label: 'Invoice Summary', visible: true, action: 'PRINT_INVOICE', isSubMenu: true, disabled: this.InvoiceId ? false : true },
              { label: 'Invoice Details', visible: true, action: 'PRINT_INVOICE_DETAILS', isSubMenu: true, disabled: this.InvoiceId ? false : true },
              { label: 'Invoice on Letterhead', visible: true, action: 'PRINT_INVOICE_PDF', isSubMenu: true, disabled: this.InvoiceId ? false : true },
              { label: 'E-Invoice on Letterhead', visible: true, action: 'PRINT_INVOICE_E_INVOICE', isSubMenu: true, disabled: this.InvoiceId ? false : true },
              { label: 'Invoice on Preprinted Letterhead', visible: true, action: 'PRINT_INVOICE_LETTERHEAD', isSubMenu: true, disabled: this.InvoiceId ? false : true },
              { label: 'E-Invoice on Preprinted Letterhead', visible: true, action: 'PRINT_INVOICE_LETTER_HEAD_E_INVOICE', isSubMenu: true, disabled: this.InvoiceId ? false : true },
              // { label: 'Invoice Details (KM/MT)', visible: true, action: 'PRINT_INVOIC_KM_MT', isSubMenu: true, disabled: this.InvoiceId ? false : true },  --(commented by fahim 14-1-2026)
              // { label: 'UB Invoice', visible: true, action: 'PRINT_UB_INVOICE', isSubMenu: true, disabled: this.InvoiceId ? false : true },   --(commented by fahim 14-1-2026)
            ]
          },
          {
            label: 'Download',
            visible: true,
            isSubMenu: true,
            children: [
              { label: 'Invoice Summary', visible: true, action: 'DOWNLOAD_SUMMARY', isSubMenu: true, disabled: this.InvoiceId ? false : true },
              { label: 'Invoice Details', visible: true, action: 'DOWNLOAD_DETAIL', isSubMenu: true, disabled: this.InvoiceId ? false : true },
              // { label: 'Invoice UB Bill', visible: true, action: 'DOWNLOAD_UB', isSubMenu: true, disabled: this.InvoiceId ? false : true }  --(commented by fahim 14-1-2026)
            ]
          },
          {
            label: 'Share',
            visible: true,
            isSubMenu: true,
            children: [
              { label: 'Send Invoice', visible: true, action: 'SEND_INVOICE', isSubMenu: true, disabled: this.InvoiceId ? false : true },
              {
                label: 'Send Reminder', visible: true, action: 'SEND_REMINDER', isSubMenu: true,
                disabled: false
              },
            ]
          },
          { label: 'Check LR Billing Status', visible: true, disabled: false },
          //added by BURHAN - 10-April-2026
          { label: 'Copy & Create New', visible: (window.location.pathname !== '/sales-invoice-new') && (this.data.IsPosted && this.data.isAvailablePaymentReceipt == 'false') ? true : false, disabled: false },
          //end by BURHAN - 10-April-2026
          { label: 'Delete', visible: true, disabled: this.InvoiceId ? false : true },
          { label: 'Notes', visible: true, disabled: false }, // added by yash 06-05-2026
        ];
        break;
      // Added by priya - 29/12/2025 - actions for payment made screen
      case 'PaymentMade':
        this.items = [
          { label: 'Edit', visible: this.ShowAction && this.commonService.CheckHasRight('EDIT', 'PAYMENTMADE_DETAILS'), disabled: false },
          { label: 'View', visible: this.ShowAction && this.commonService.CheckHasRight('VIEW', 'PAYMENTMADE_DETAILS'), disabled: false },
          {
            label: 'Print',
            visible: this.data && this.data.Id ? true : false, //condition added by burhan - 18-Feb-2026 - replaced with 'true'
            isSubMenu: true,
            children: [
              { label: 'Print Voucher', visible: true, action: '', isSubMenu: true, disabled: this.InvoiceId ? false : true },
              { label: 'Print Payment Advice', visible: true, action: '', isSubMenu: true, disabled: this.InvoiceId ? false : true },
              { label: 'Print Detail Payment Advice', visible: true, action: '', isSubMenu: true, disabled: this.InvoiceId ? false : true },
            ]
          },
          { label: 'Delete', visible: this.data && this.data.Id ? true : false, disabled: this.InvoiceId ? false : true },
          { label: 'Notes', visible: true, disabled: this.InvoiceId ? false : true},  // added by yash 26-05-2026
        ];
        break;
      case 'PaymentReceipt':
        this.items = [
          { label: 'Edit', visible: this.ShowAction, disabled: false },
          { label: 'View', visible: this.ShowAction, disabled: false },
          // { label: 'Print Voucher', visible: true, disabled: this.InvoiceId ? false : true },//added by Burhan - 19-Feb-2026 - New Print Added
          { label: 'Delete', visible: this.data && this.data.Id ? true : false, disabled: this.InvoiceId ? false : true },
          { label: 'Notes', visible: true, disabled: false }, // added by yash 07-05-2026
        ]
        break;
      //added by burhan - 13-Feb-2026
      case 'PurchaseBill':
        this.items = [
          { label: 'Edit', visible: this.ShowAction, disabled: false },
          { label: 'View', visible: this.ShowAction, disabled: false },
          { label: 'Attachments', visible: this.ShowAction, disabled: false },
          { label: 'Delete', visible: true, disabled: this.InvoiceId ? false : true },
          { label: 'Print Details', visible: true, disabled: this.InvoiceId ? false : true },
          { label: 'Copy & Create New', visible: (window.location.pathname !== '/purchase-bills') && (this.data.IsPosted) ? true : false, disabled: false }, // Added by priya - 06/05/2026 - cn(PRIYA-MAY26-001)
          { label: 'Notes', visible: true, disabled: false },  // added by yash 28-05-2026
        ]
        break;
      //ended by burhan - 13-Feb-2026
      // Added by priya - 13/01/2026 - CN(PRIYA-JAN26-010)
      case 'TollPlaza':
        this.items = [
          { label: 'Edit', visible: this.ShowAction && this.commonService.CheckHasRight('EDIT', 'TollPlaza_Details'), disabled: false },
          { label: 'View', visible: this.ShowAction && this.commonService.CheckHasRight('VIEW', 'TollPlaza_Details'), disabled: false },
          { label: 'Delete', visible: true && this.commonService.CheckHasRight('DELETE', 'TollPlaza_Details'), disabled: this.InvoiceId ? false : true },
        ];
        break;
      case 'GateManagement':
        this.items = [
          { label: 'Edit', visible: this.ShowAction, disabled: false },
          { label: 'Delete', visible: true, disabled: this.InvoiceId ? false : true },
          { label: 'Print Gate Pass', visible: true, disabled: this.InvoiceId ? false : true },
          { label: 'Mark as Gate Out', visible: !(this.data && this.data.MarkedGateOut), disabled: this.InvoiceId ? false : true },
        ];
        break;
      // Added by priya - 09/02/2026 - actions for eway bill log detail - CN(PRIYA-JAN26-017)
      case 'EwayBillDetail':
        this.items = [
          { label: 'Generate Part B', visible: (this.data.EwayBillNo !== '' && this.data.IsEwayPartBFiled !== 'Filed'), disabled: false },
          { label: 'Update EwayBill', visible: (this.data.EwayBillNo !== '' && this.data.IsEwayPartBFiled === 'Filed'), disabled: false },
          { label: 'Extend EwayBill', visible: (this.data.EwayBillNo !== '' && this.data.IsEwayBillExtended !== 'Extended') , disabled: false },
          { label: 'Print EwayBill', visible: (this.data.EwayBillNo !== '') , disabled: false },
        ];
        break;
      // Added by priya - 12/02/2026 - actions for Payment Request - CN(PRIYA-JAN26-017)
      case 'PaymentRequest':
        this.items = [
          // { label: 'Make Payment', visible: !this.data.IsAdvanceMade, disabled: false },
          { label: 'Print Expense Voucher', visible: true, disabled: false },
        ];
        break;
      // added by fahim 28-2-2026
      case 'JournalEntry':
        this.items = [
          { label: 'Edit', visible: this.commonService.CheckHasRight('EDIT', 'JournalEntry_DETAILS'), disabled: false },
          { label: 'View', visible: this.commonService.CheckHasRight('VIEW', 'JournalEntry_DETAILS'), disabled: false },
          { label: 'Delete', visible: this.commonService.CheckHasRight('DELETE', 'JournalEntry_DETAILS'), disabled: false },
          { label: 'Print', visible: this.commonService.CheckHasRight('PRINT', 'JournalEntry_DETAILS'), disabled: false },
          { label: 'Notes', visible: true, disabled: false}, // added by yash 06-05-2026
        ];
        break;
      //added by BURHAN - 13-May-2026
      case 'Attachments':
        this.items = [
          { label: 'Attachments', name: 'Attachments', icon: 'fa-paperclip' }
        ];
        break;
      //end by BURHAN      
      default:
        this.items = [];
        break;
    }

    this.items = this.items.filter(x => x.visible);
  }

  // toggleDropdown(event: MouseEvent) {
  //   event.stopPropagation();
  //   this.isOpen = !this.isOpen;
  // }

  toggleDropdown(event: MouseEvent) {
    event.stopPropagation();

    // close other dropdowns
    if (this.selectedIndex !== this.cardIndex) {
      this.isOpen = true;
    } else {
      this.isOpen = !this.isOpen;
    }

    if (this.isOpen) {
      this.dropdownOpened.emit(this.cardIndex);  // notify parent
      // setTimeout(() => this.adjustDropdownPosition(event), 0);
    }
  }


  onSelect(event: any) {
    // console.log('event', event, this.data)
    if (this.type == 'SalesInvoice') {
      var actionName = "";
      if (event && typeof event === 'object' && 'isSubMenu' in event && event.isSubMenu === true) {
        actionName = event.label;
      } else {
        actionName = event.target.innerText ? event.target.innerText : event;
      }

      if (actionName === 'Download Invoice Summary') {
        this.OnDownloadClick(this.InvoiceId, 'Summary', 'Download');
      } else if (actionName == 'Invoice Detail') {
        this.OnDownloadClick(this.InvoiceId, 'Detail', 'Download');
      } else if (actionName == 'Invoice UB Bill') {
        this.OnDownloadClick(this.InvoiceId, 'AllInOne', 'Download');
      } else if (actionName == 'Send For E-Invoice') {
        this.Generate_EInvoice(this.InvoiceId);
      } else if (actionName == 'Cancel E-Invoice') {
        this.open_cancleEInvoiceMode();
      } else if (actionName == 'Send Invoice') {
        this.OpenSendMail();
      } else if (actionName == 'Delete') {
        this.DeleteInvoiceById();
      } else if (actionName == 'Check LR Billing Status') {
        this.OpenLRStatusModal();
      } else if (actionName == 'Invoice Summary') {
        this.GetPrintData(this.InvoiceId, 'Summary', 'Print');
      } else if (actionName == 'Invoice Details') {
        this.GetPrintData(this.InvoiceId, 'Detail', 'Print');
      } else if (actionName == 'Invoice on Letterhead') {
        this.GetPrintData(this.InvoiceId, 'Detail1', 'Print');
      } else if (actionName == 'E-Invoice on Letterhead') {
        this.GetPrintData(this.InvoiceId, 'PDF_EInvoice', 'Print');
      } else if (actionName == 'Invoice on Preprinted Letterhead') {
        this.GetPrintData(this.InvoiceId, 'Detail1OnLatterPad', 'Print');
      } else if (actionName == 'E-Invoice on Preprinted Letterhead') {
        this.GetPrintData(this.InvoiceId, 'OnLatterPad_EInvoice', 'Print');
      } else if (actionName == 'Invoice Details (KM/MT)') {
        this.GetPrintData(this.InvoiceId, 'Detail_KM_MT', 'Print');
      } else if (actionName == 'UB Invoice') {
        this.GetPrintData(this.InvoiceId, 'AllInOne', 'Print');
      } else if (actionName == 'Edit') {
        this.router.navigateByUrl(`/sales-invoice-new/edit/${this.InvoiceId}`);
      } else if (actionName == 'View') {
        this.goToDetailsPage(this.data)
      }
      //added by BURHAN - 10-April-2026
      else if( actionName == 'Copy & Create New') {
        SalesInvoiceFormComponent.that.CopyAndCreateNew();
      }
      // added by yash 06-05-2026
      else if (actionName == 'Notes') {
        this.itemSelected.emit({ target: { innerText: 'Notes' }, actionName: 'Notes', row: this.data, type: this.type });
      }
      // end by yash 06-05-2026
    } 
    //added by burhan - 11-Feb-2026
    else if(this.type === 'CashExpense'){
      var actionName = "";
      if (event && typeof event === 'object' && 'isSubMenu' in event && event.isSubMenu === true) {
        actionName = event.label;
      } else {
        actionName = event.target.innerText ? event.target.innerText : event;
      }

      if (actionName == 'Edit') {
        this.router.navigateByUrl(`/cash-expense/edit/${this.data.Id}`);
      } else if (actionName == 'View') {
        this.goToDetailsPage(this.data)
        // this.router.navigateByUrl(`/cash-expense/view/${this.InvoiceId}`);
      } else if (actionName == 'Delete') {
        this.DeleteCashExpenseById();
        //this.DeleteBillPaymentById()
      }
      //add by burhan - 13-Feb-2026
      else if(actionName == 'Print Expense Voucher'){
        //console.log('event', event, this.InvoiceId)
        this.PrintExpenseVoucher2(this.data.Id, this.userId)
      }
      //end

      // added by yash 07-05-2026
      else if (actionName == 'Notes') {
        this.itemSelected.emit({ target: { innerText: 'Notes' }, actionName: 'Notes', row: this.data, type: this.type });
      }
      // end by yash 07-05-2026
    }
    //added by BURHAN - 10-March-2026
    else if (this.type === 'PendingInvoiceConsignment') {
      var actionName = "";
      if (event && typeof event === 'object' && 'isSubMenu' in event && event.isSubMenu === true) {
        actionName = event.label;
      } else {
        actionName = event.target.innerText ? event.target.innerText : event;
      }

      if (actionName == 'View Trips') {
        this.router.navigateByUrl(`/cash-expense/edit/${this.data.Id}`);
      } else if (actionName == 'Generate Invoice') {
        this.goToDetailsPage(this.data)
        // this.router.navigateByUrl(`/cash-expense/view/${this.InvoiceId}`);
      }

    }
    //end by BURHAN - 10-March-2026
    //added by burhan - 12-Feb-2026
    else if (this.type === 'CashReceipt') {
      var actionName = "";
      if (event && typeof event === 'object' && 'isSubMenu' in event && event.isSubMenu === true) {
        actionName = event.label;
      }
      // added by yash 07-05-2026
      else if (actionName == 'Notes') {
        this.itemSelected.emit({ target: { innerText: 'Notes' }, row: this.data, actionName: actionName, type: this.type  });
      }
      // end by yash 07-05-2026 
      else {
        actionName = event.target.innerText ? event.target.innerText : event;
      }

      // if (actionName == 'Edit') {
      //   this.router.navigateByUrl(`/cash-expense/edit/${this.data.Id}`);
      // } else if (actionName == 'View') {
      //   this.goToDetailsPage(this.data)
      //   // this.router.navigateByUrl(`/cash-expense/view/${this.InvoiceId}`);
      // } else 
      if (actionName == 'Delete') {
        this.DeleteCashReceiptById();
        //this.DeleteBillPaymentById()
      }
    }
    //ended by burhan - 12-Feb-2026
    //ended by burhan - 11-Feb-2026
    else if (this.type === 'PaymentMade') {
      var actionName = "";
      if (event && typeof event === 'object' && 'isSubMenu' in event && event.isSubMenu === true) {
        actionName = event.label;
      } else {
        actionName = event.target.innerText ? event.target.innerText : event;
      }
      if (actionName == 'Edit') {
        this.router.navigateByUrl(`/new-payment-made/edit/${this.InvoiceId}`);
      } else if (actionName == 'View') {
        this.goToDetailsPage(this.data)
      } else if (actionName == 'Delete') {
        this.DeleteBillPaymentById()
      } else if (actionName == 'Print Payment Advice') {
        Helpers.setLoading(true);
        this.GetPaymentMadePrints(this.InvoiceId, this.data.VendorId, 'PrintPaymentAdvice')
      } else if (actionName == 'Print Detail Payment Advice') {
        Helpers.setLoading(true);
        this.GetPaymentMadePrints(this.InvoiceId, this.data.VendorId, 'PrintDetailPaymentAdvice')
      }
      //added by burhan - 23-Feb-2026
      else if(actionName == 'Print Voucher'){
        Helpers.setLoading(true);
        this.PrintPaymentDetails(this.InvoiceId);
      }
      // added by yash 07-05-2026
      else if (actionName == 'Notes') {
        this.itemSelected.emit({ target: { innerText: 'Notes' }, row: this.data, actionName: actionName, type: this.type  });
      }
      // end by yash 07-05-2026
    } 
    else if (this.type == 'PaymentReceipt') {
      var actionName = "";
      if (event && typeof event === 'object' && 'isSubMenu' in event && event.isSubMenu === true) {
        actionName = event.label;
      } else {
        actionName = event.target.innerText ? event.target.innerText : event;
      }

      if (actionName == 'Delete') {
        this.DeleteReceipt();
      }
      //added by burhan - 13-Feb-2026
      else if(actionName == 'Edit') {
        this.router.navigateByUrl(`/new-payment-received/edit/${this.InvoiceId}`);
      }
      else if (actionName == 'View') {
        this.router.navigateByUrl(`/new-payment-received/view/${this.InvoiceId}`);
      }
      //added by burhan - 19-Feb-2026
      else if(actionName == 'Print Voucher'){
        Helpers.setLoading(true);
        this.PrintPaymentReceiptVoucher2(this.InvoiceId)
      }
      //end by burhan - 19-Feb-2026
      //ended by burhan - 13-Feb-2026
      // else if (actionName == 'Edit') {
      //   this.router.navigateByUrl(`/new-payment-received/edit/${this.data.Id}`);
      // } else if (actionName == 'View') {
      //   this.router.navigateByUrl(`/new-payment-received/view/${this.data.Id}`);
      // }

      // added by yash 07-05-2026
      else if (actionName == 'Notes') {
        // this.itemSelected.emit({ target: { innerText: 'Notes' }, row: this.data, actionName: actionName });
        this.itemSelected.emit({ target: { innerText: 'Notes' }, actionName: 'Notes', row: this.data });
      }
      // end by yash 07-05-2026

    }
    //added by BURHAN - 13-Feb-2026
    else if (this.type == 'PurchaseBill') {
      var actionName = "";
      if (event && typeof event === 'object' && 'isSubMenu' in event && event.isSubMenu === true) {
        actionName = event.label;
      } else {
        actionName = event.target.innerText ? event.target.innerText : event;
      }

      if (actionName == 'Delete') {
        this.BillDelete();
      }
      else if (actionName == 'Edit') {
        this.router.navigateByUrl(`/purchase-bills/edit/${this.InvoiceId}`);
      }
      else if (actionName == 'View') {
        this.router.navigateByUrl(`/purchase-bills/view/${this.InvoiceId}`);
      } else if (actionName == 'Print Details'){
        Helpers.setLoading(true);
        this.PrintPurchaseBillDetails('Detail')
      } else if (actionName == 'Copy & Create New') { // Added by priya - 06/05/2026 - cn(PRIYA-MAY26-001)
        PurchaseBillsFormComponent.that.CopyAndCreateNew();
      }
      // added by yash 28-05-2026
      else if (actionName === 'Notes') {
        this.itemSelected.emit({ target: { innerText: 'Notes' } , actionName: 'Notes', row: this.data, type: this.type });
      } 
      // end by yash 28-05-2026
      //added by BURHAN - 30-June-2026
      else if (actionName === 'Attachments') {
      this.itemSelected.emit({
        target: { innerText: 'Attachments' },
        actionName: 'Attachments',
        row: this.data,
        type: this.type
      });
      //end by BURHAN - 30-June-2026
    }
    }
    //ended by BURHAN - 13-Feb-2026
     else if (this.type === 'FtlList') { //added by fahim 31-12-2025
      let PrintName = event.target.innerText ? event.target.innerText : event;
      if(PrintName === 'Cancel Order'){
        this.ModalTitle='Cancel Order'
        this.ReasonFor='Order'
        this.cancelType='FTL'
        this.selectedId=this.data.Id;
        this.onCancelClick('order');
      } else if (PrintName === 'Print Trip Profitibilty'){ // Added by priya - 10/01/2026
          this.PrintTripProfibility(this.data.Id, this.data.BookingId)
      } else if (PrintName === 'Eway Bill Log') { // Added by priya - 31/01/2026 - cn(PRIYA-JAN26-015)
        this.ModalTitle = 'Eway Bill Log';
        this.OrderId = this.data.Id;
        this.OpenEwayBillLogModal();
      }
      // added by yash 12-05-2026
      else if (PrintName === 'Notes') {
        this.itemSelected.emit({ target: { innerText: 'Notes' } , actionName: 'Notes', row: this.data, type: this.type });
      } 
      // end by yash 12-05-2026
      else {
        this.itemSelected.emit(event);
      }
    } else if (this.type === 'LTLList') {
      let PrintName = event.target.innerText ? event.target.innerText : event;
      if(PrintName === 'Cancel Order'){
        this.ModalTitle='Cancel Order'
        this.ReasonFor='Order'
        this.cancelType='LTL'
        this.selectedId=this.data.Id;
        this.onCancelClick('order');
      } else if (PrintName === 'Print Trip Profitibilty') { // Added by priya - 10/01/2026
        this.PrintTripProfibility(this.data.Id, this.data.BookingId)
      } else if (PrintName === 'Eway Bill Log') { // Added by priya - 31/01/2026 - cn(PRIYA-JAN26-015)
        this.ModalTitle = 'Eway Bill Log';
        this.OrderId = this.data.Id;
        // console.log('this.data.IndentId', this.data.IndentId, this.data)
        this.OpenEwayBillLogModal();
      }
      // added by yash 23/04/2026
      else if (PrintName === 'Notes'){
        this.itemSelected.emit({ target: { innerText: 'Notes'} });
      }
      // end by yash 23/04/2026 
      else {
        this.itemSelected.emit(event);
      }
    } else if (this.type === 'FtlContainerList') {
      let PrintName = event.target.innerText ? event.target.innerText : event;
      if(PrintName === 'Cancel Order'){
        this.ModalTitle='Cancel Order'
        this.ReasonFor='Order'
        this.cancelType='ContainerMovement'
        this.selectedId=this.data.Id;
        this.onCancelClick('order');
      } else if (PrintName === 'Print Trip Profitibilty') { // Added by priya - 10/01/2026
        this.PrintTripProfibility(this.data.Id, this.data.BookingId)
      } else if (PrintName === 'Eway Bill Log') { // Added by priya - 31/01/2026 - cn(PRIYA-JAN26-015)
        this.ModalTitle = 'Eway Bill Log';
        this.OrderId = this.data.Id;
        // console.log('this.data.IndentId', this.data.IndentId, this.data)
        this.OpenEwayBillLogModal();
      }
      // added by yash 12-05-2026
      else if (PrintName === 'Notes') {
        this.itemSelected.emit({ target: { innerText: 'Notes'} });
      } 
      // end by yash 12-05-2026
      else {
        this.itemSelected.emit(event);
      }
    } else if (this.type === 'FtlTripActions') {
      let PrintName = event.target.innerText ? event.target.innerText : event;
      if(PrintName === 'Cancel Booking'){
        this.ModalTitle='Cancel Booking'
        this.ReasonFor='Booking'
        this.cancelType='FTL'
        this.selectedId=this.data.BookingId;
        this.onCancelClick('booking');
      } else if (PrintName === 'Eway Bill Log'){
        this.ModalTitle = 'Eway Bill Log';
        this.ConsignmentDetailId = this.data.ConsignmentDetailId;
        this.BookingId = this.data.BookingId;
        this.OrderId = this.data.IndentId;
        this.OpenEwayBillLogModal();
      } else if (PrintName === 'Add Orders'){ //Added by fahim 03-02-2026 :)
        this.BookingId = this.data.BookingId;
        this.OrderId = this.data.IndentId;
        this.CustomerId = this.data.CustomerId;
        this.openAddOrdersModal();
      } else if (PrintName === 'Check Driver Consent') { // Added by priya - 02/04/2026 - cn(PRIYA-APR26-001)
        this.BookingId = this.data.BookingId;
        this.DriverMobileNo = this.data.DriverMobileNo;
        this.OpenDriverConsentModal();
      }
      // added by yash 23/04/2026
      else if (PrintName === 'Notes'){
        this.itemSelected.emit({ actionName: 'Notes', row: this.data, type: this.type });
      }
      // end by yash 23/04/2026
      //added by BURHAN - 3-March-2026
      else if (PrintName === 'Print Alpha LR') {
        this.PrintFormatsNewComponent.PrintFormatsChild.InvoiceType = "PrintLorryReceipt5";
        this.PrintFormatsNewComponent.PrintFormatsChild.From = "Destination";
        this.PrintFormatsNewComponent.PrintFormatsChild.ConsignmentNoteId = this.data.ConsignmentDetailId;
        this.PrintFormatsNewComponent.PrintFormatsChild.CompId = this.CompanyId;
        this.PrintFormatsNewComponent.PrintFormatsChild.PrintInvoice()



        // this.PrintFormatsNewComponent.OrderId = OrderId;
        // this.PrintFormatsNewComponent.BookingId = BookingId;
        // this.PrintFormatsNewComponent.UserId = this.userId;
        // this.PrintFormatsNewComponent.CompanyId = this.CompanyId;
        // this.PrintFormatsNewComponent.PrintTripProfibility();
      }
        //end by BURHAN
      // Added by priya - 09/06/2026 - cn(PRIYA-JUN26-002)
      else if (PrintName == 'Print Lorry Receipt') {
        this.PrintFormatsNewComponent.PrintDropdownData('Print Lorry Receipt', this.data);
        // this.PrintFormatsNewComponent.GetLorryReceiptPrint4(this.data.ConsignmentDetailId, 'Destination');
      } else if (PrintName === 'Terms And Condition For LR') {
        this.PrintFormatsNewComponent.CompanyId = this.CompanyId;
        this.PrintFormatsNewComponent.PrintDropdownData('Terms And Condition For LR', this.data);
        // this.PrintFormatsNewComponent.GetTermsAndConditionsForLR()
      }
      // End by priya
       else {
        this.itemSelected.emit(event);
      }
    } else if (this.type === 'FtlContainerTripActions') {
      let PrintName = event.target.innerText ? event.target.innerText : event;
      if(PrintName === 'Cancel Booking'){
        this.ModalTitle='Cancel Booking'
        this.ReasonFor='Booking'
        this.cancelType='ContainerMovement'
        this.selectedId=this.data.BookingId;
        this.onCancelClick('booking');
      } else if (PrintName === 'Check Driver Consent') { // Added by priya - 02/04/2026 - cn(PRIYA-APR26-001)
        this.BookingId = this.data.BookingId;
        this.DriverMobileNo = this.data.DriverMobileNo;
        this.OpenDriverConsentModal();
      }
      // added by yash 23/04/2026
      else if (PrintName === 'Notes'){
        this.itemSelected.emit({ actionName: 'Notes', row: this.data, type: this.type });
      }
      // end by yash 23/04/2026
      // Added by priya - 09/06/2026 - cn(PRIYA-JUN26-002)
      else if (PrintName == 'Print Lorry Receipt'){
        this.PrintFormatsNewComponent.PrintDropdownData('Print Lorry Receipt 2', this.data);
      }
      // End by priya
       else {
        this.itemSelected.emit(event);
      }
    } else if (this.type === 'TollPlaza') {
      var actionName = "";
      if (event && typeof event === 'object' && 'isSubMenu' in event && event.isSubMenu === true) {
        actionName = event.label;
      } else {
        actionName = event.target.innerText ? event.target.innerText : event;
      }
      if (actionName == 'Edit') {
        this.router.navigateByUrl(`/TollPlaza/edit/${this.InvoiceId}`);
      } else if (actionName == 'View') {
        this.goToDetailsPage(this.data)
      } else if (actionName == 'Delete') {
        this.DeleteTollPlazaById()
      } 
    } else if (this.type === 'EwayBillDetail') { // Added by priya - 09/02/2026 - cn(PRIYA-JAN26-017)
      var actionName = "";
      if (event && typeof event === 'object' && 'isSubMenu' in event && event.isSubMenu === true) {
        actionName = event.label;
      } else {
        actionName = event.target.innerText ? event.target.innerText : event;
      }
      if (actionName == 'Generate Part B') {
        let BookingId: any = this.data.BookingId;
        let ConsignmentDetailId: any = this.data.ConsignmentDetailId;
        this.GetEwayLrData(BookingId, ConsignmentDetailId)
        setTimeout(() => {
          this.GeneratePartB(BookingId, ConsignmentDetailId);
        }, 300);
      } else if (actionName == 'Extend EwayBill') {
        let BookingId: any = this.data.BookingId;
        let ConsignmentDetailId: any = this.data.ConsignmentDetailId;
        this.OpenExtendEwayBillModal();
        // this.ExtendEwayBill(this.data);
      } else if (actionName == 'Update EwayBill') {
        let BookingId: any = this.data.BookingId;
        let ConsignmentDetailId: any = this.data.ConsignmentDetailId;
        this.OpenChangeTransVehDriModal()
      } else if (actionName == 'Print EwayBill') {
        let EwayBillNo: any = this.data.EwayBillNo;
        let ConsignmentDetailId: any = this.data.ConsignmentDetailId;
        this.PrintEwayBill(ConsignmentDetailId, EwayBillNo);
      }
    } else if (this.type === 'PaymentRequest') { // Added by priya - 12/02/2026 - cn(PRIYA-FEB26-003)
      var actionName = "";
      if (event && typeof event === 'object' && 'isSubMenu' in event && event.isSubMenu === true) {
        actionName = event.label;
      } else {
        actionName = event.target.innerText ? event.target.innerText : event;
      }
      if (actionName == 'Make Payment') {
        this.MakePayment();
      } else if (actionName == 'Print Expense Voucher') {
        this.PrintExpenseVoucher(this.data.BookingId, this.userId)
      }
    } else if (this.type === 'JournalEntry') { //added by fahim 02-03-2026
      var actionName = "";
      if (event && typeof event === 'object' && 'isSubMenu' in event && event.isSubMenu === true) {
        actionName = event.label;
      } else {
        actionName = event.target.innerText ? event.target.innerText : event;
      }
      if (actionName == 'Edit') {
        this.router.navigateByUrl(`/new-journal-entry/edit/${this.data.Id}`);
      } else if (actionName == 'View') {
        this.router.navigateByUrl(`/new-journal-entry/view/${this.data.Id}`);
      } else if (actionName == 'Delete') {
        this.deleteJVData(this.data.Id)
      } else if (actionName == 'Print') {
        this.PrintJournalEntry(this.data.Id)
      } 
      // added by yash 06-05-2026
      else if (actionName == 'Notes') {
        this.itemSelected.emit(
          { target: { innerText: 'Notes'} , actionName: 'Notes', row: this.data, type: this.type}
        );
      }
      // end by yash 06-05-2026
    } else if (this.type === 'GateManagement'){
      var actionName = "";
      if (event && typeof event === 'object' && 'isSubMenu' in event && event.isSubMenu === true) {
        actionName = event.label;
      } else {
        actionName = event.target.innerText ? event.target.innerText : event;
      }
      if (actionName == 'Edit') {
        this.router.navigateByUrl(`/GateManagement/edit/${this.data.Id}`);
      } else if (actionName == 'Delete'){
        this.DeleteGateData(this.data.Id);
      } else if (actionName.trim() == "Print Gate Pass") {
        this.PrintGatePass(this.data.Id);
      } else if (actionName.trim() == "Mark as Gate Out") {
        this.MarkAsGateOut(this.data.Id);
      }
    } else {
      this.itemSelected.emit(event);
    }
    this.isOpen = false;
  }

  goToDetailsPage(rowData: any) {
    var obj: any = {};
    if (this.type === 'SalesInvoice') {
      if (this.filterObj) {
        obj = {
          invoiceId:
            this.filterObj && this.filterObj.InvoiceNo ? this.filterObj.InvoiceNo : null,

          customerIdMulti:
            this.filterObj && this.filterObj.Customer ? this.filterObj.Customer : null,

          tripId:
            this.filterObj && this.filterObj.TripNo ? this.filterObj.TripNo : null,

          fromDate:
            this.filterObj && this.filterObj.StartDate ? this.filterObj.StartDate : null,

          toDate:
            this.filterObj && this.filterObj.EndDate ? this.filterObj.EndDate : null,

          Financialyear:
            this.filterObj && this.filterObj.AccountYear ? this.filterObj.AccountYear : null,

          status:
            this.filterObj && this.filterObj.Status ? this.filterObj.Status : null,

          InvoiceTypeId:
            this.filterObj && this.filterObj.InvoiceType ? this.filterObj.InvoiceType : null,

          isEmailsent:
            this.filterObj && this.filterObj.EmailSent ? this.filterObj.EmailSent : null
        };
      }
      localStorage.setItem('SalesinvoiceFilter', JSON.stringify(obj));
      this.router.navigateByUrl(`/sales-invoice-new/view/${rowData.Id}`);
    } 
    //added by BURHAN - 12-Feb-2026
    else if (this.type === 'CashReceipt') {
      if (this.filterObj) {
        const obj = {
          BillId: this.filterObj && this.filterObj.ExpenseNo ? this.filterObj.ExpenseNo : null,
          AccountId: this.filterObj && this.filterObj.ExpenseAccount ? this.filterObj.ExpenseAccount : null,
          PaidThrough: this.filterObj && this.filterObj.PaidThrough ? this.filterObj.PaidThrough : null,
          VehicleNo: this.filterObj && this.filterObj.VehicleList ? this.filterObj.VehicleList : null,
          FromDate: this.filterObj && this.filterObj.StartDate ? this.filterObj.StartDate : null,
          ToDate: this.filterObj && this.filterObj.EndDate ? this.filterObj.EndDate : null,
          Financialyear: this.filterObj && this.filterObj.AccountYear ? this.filterObj.AccountYear : null,
          Status: this.filterObj && this.filterObj.Status ? this.filterObj.Status : null,
        };
      }
      localStorage.setItem('CashReceiptFilter', JSON.stringify(obj));
      //this.router.navigateByUrl(`/cash-expense/view/${this.data.Id}`);
    }
    //ended by BURHAN - 12-Feb-2026
    else if (this.type === 'CashExpense') {
      if (this.filterObj) {
        const obj = {
          BillId: this.filterObj && this.filterObj.ExpenseNo ? this.filterObj.ExpenseNo : null,
          AccountId: this.filterObj && this.filterObj.AccountNo ? this.filterObj.AccountNo : null,
          VehicleNo: this.filterObj && this.filterObj.VehicleNo ? this.filterObj.VehicleNo : null,
          PaidThrough: this.filterObj && this.filterObj.PaidThrough ? this.filterObj.PaidThrough : null,
          Financialyear: this.filterObj && this.filterObj.AccountingYear ? this.filterObj.AccountingYear : null,
          FromDate: this.filterObj && this.filterObj.FromDate ? this.filterObj.FromDate : null,
          ToDate: this.filterObj && this.filterObj.ToDate ? this.filterObj.ToDate : null,
          Status: this.filterObj && this.filterObj.Status ? this.filterObj.Status : null,
        };
      }
      localStorage.setItem('CashExpenseFilter', JSON.stringify(obj));
      this.router.navigateByUrl(`/cash-expense/view/${this.data.Id}`);
     } else if (this.type === 'PaymentMade') {
      console.log('rowData', rowData)
      this.router.navigateByUrl(`/new-payment-made/view/${rowData.Id}`);
    } 
    // Added by priya - 14/01/2026 - CN(PRIYA-JAN26-010)
    else if(this.type === 'TollPlaza'){
      if(this.filterObj){
        obj = {
          PlazaType: this.filterObj && this.filterObj.PlazaType ? this.filterObj.PlazaType : null,
          PlazaSubType: this.filterObj && this.filterObj.PlazaSubType ? this.filterObj.PlazaSubType : null,
          State: this.filterObj && this.filterObj.State ? this.filterObj.State : null,
          City: this.filterObj && this.filterObj.City ? this.filterObj.City : null,
        };
        localStorage.setItem('TollPlazaFilter', JSON.stringify(obj));
        localStorage.setItem('showMap', 'false');
        this.router.navigateByUrl(`/TollPlaza/view/${rowData.Id}`);
      }
    }
  }

  // @HostListener('document:click', ['$event'])
  // handleClickOutside(event: MouseEvent) {
  //   if (this.isOpen && !this.eRef.nativeElement.contains(event.target)) {
  //     this.isOpen = false;
  //   }
  // }

  adjustDropdownPosition(event: MouseEvent) {
    const button = event.target as HTMLElement;

    let dropdownMenu: HTMLElement = null;
    if (button.parentElement) {
      dropdownMenu = button.parentElement.querySelector('.dropdown-menu') as HTMLElement;
    }
    if (!dropdownMenu) return;

    const rect = dropdownMenu.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;

    this.openUpwards = (spaceBelow < 150 && spaceAbove > 150);
  }

  //Sales Invoice
  GetLoginCompanyData() {
    this.SelectedComapnyName = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).SelectedComapnyName;
    this.SelectedCompanyAdd = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).SelectedCompanyAdd;
    this.SelectedCompanyCIN = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).SelectedCompanyCIN;
    this.SelectedCompantGSTIN = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).SelectedCompantGSTIN;
    this.SelectedCompanyGSTCode = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).GSTCode;
    this.SelectedCompanyLogo = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).CompanyLogoPath;
    this.SelectedCompanyLogo = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).CompanyLogoPath;
    this.SelectedCompanyPAN = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).SelectedCompanyPAN;

    $(".SalesLogoImg").attr(
      "src",
      environment.apiUrl + this.SelectedCompanyLogo
    );

    this.SelectedCompanyLogoImg = environment.apiUrl + this.SelectedCompanyLogo;
  }

  OnDownloadClick(Data, Type, ToDo) {
    Helpers.setLoading(true);
    if (Type == "PrintInvoiceAnnexureMR4Movement") {
      this._appService
        .GetByTwoId(
          "Sales",
          "inv_DownloadInvoiceAnnexureMR4MovementKSH",
          Data,
          Type
        )
        .subscribe(
          (response) => {
            $("#DownloadInvoice").val("");
            this.DownloadFile(response);
            Helpers.setLoading(false);
          },
          (err) => {
            $("#DownloadInvoice").val("");
            Helpers.setLoading(false);
            this.toastr.error("An error occured Downaloding !", "error");
          }
        );
    } else {
      this.GetPrintData(Data, Type, ToDo);
      setTimeout(() => {
        for (var i = 0; i < this.PrintData.length; i++) {
          this.PrintData[i].SelectedComapnyName = this.SelectedComapnyName;
          this.PrintData[i].SelectedCompanyCIN = this.SelectedCompanyCIN;
          this.PrintData[i].SelectedCompantGSTIN = this.SelectedCompantGSTIN;
          this.PrintData[i].SelectedCompanyAdd = this.SelectedCompanyAdd;
          this.PrintData[i].SelectedCompanyPAN = this.SelectedCompanyPAN;
          if (Type == "Summary") {
            this._appService
              .Post("Sales", "ExportInvoiceSummaryData", this.PrintData[i])
              .subscribe(
                (response) => {
                  $("#DownloadInvoice").val("");
                  this.DownloadFile(response);
                  Helpers.setLoading(false);
                },
                (err) => {
                  Helpers.setLoading(false);
                  this.toastr.error("An error occured Downaloding !", "error");
                }
              );
          }
          if (Type == "Detail") {
            this._appService
              .Post("Sales", "ExportInvoiceDetailData", this.PrintData[i])
              .subscribe(
                (response) => {
                  $("#DownloadInvoice").val("");
                  this.DownloadFile(response);
                  Helpers.setLoading(false);
                },
                (err) => {
                  Helpers.setLoading(false);
                  this.toastr.error("An error occured Downaloding !", "error");
                }
              );
          }
          if (Type == "AllInOne") {
            this._appService
              .Post("Sales", "ExportUBBillData", this.PrintData[i])
              .subscribe(
                (response) => {
                  $("#DownloadInvoice").val("");
                  this.DownloadFile(response);
                  Helpers.setLoading(false);
                },
                (err) => {
                  Helpers.setLoading(false);
                  this.toastr.error("An error occured Downaloding !", "error");
                }
              );
          }
          if (Type == "PrintInvoiceAnnexureformatGeneralKSH") {
            this._appService
              .Post(
                "Sales",
                "DownloadInvoiceAnnexureformatGeneralKSH",
                this.PrintData[i]
              )
              .subscribe(
                (response) => {
                  $("#DownloadInvoice").val("");
                  this.DownloadFile(response);
                  Helpers.setLoading(false);
                },
                (err) => {
                  Helpers.setLoading(false);
                  this.toastr.error("An error occured Downaloding !", "error");
                }
              );
          }
        }
      }, 1500);
    }
  }

  DownloadFile(FileContent) {
    var byteNumbers = new Array(FileContent.Content.length);
    for (var i = 0; i < FileContent.Content.length; i++) {
      byteNumbers[i] = FileContent.Content.charCodeAt(i);
    }
    var blob = this.commonService.b64toBlob(
      FileContent.Content,
      FileContent.ContentType
    );
    let url = window.URL.createObjectURL(blob);
    $("#DownLoadFileSalesReport").attr("href", url);
    $("#DownLoadFileSalesReport").attr("download", FileContent.FileName);
    let element: HTMLElement = document.getElementById(
      "DownLoadFileSalesReport"
    ) as HTMLElement;
    element.attributes;
    element.click();
  }

  PrintData: any = [];
  PrintDataModal: any = {};
  TaxApplicableFlag: boolean = false;
  RoundOfAmount: any = 0;
  InvoiceTypeName: any;
  GetPrintData(
    Id, Type, ToDo) {
    Helpers.setLoading(true);
    this.PrintDataModal.InvoiceId = Id;
    if (Type == 'Detail1OnLatterPad' || Type == 'PDF_EInvoice' || Type == 'OnLatterPad_EInvoice') {
      this.PrintDataModal.Type = 'Detail1';
    } else {
      this.PrintDataModal.Type = Type;
    }

    if (Type == 'PrintInvoiceKSH' || Type == 'PrintInvoiceKSHSummary') {
      this._appService.Post("Sales", "GetPrintDataKSH", this.PrintDataModal).subscribe((response) => {
        this.PrintData = response;
        for (var i = 0; i < this.PrintData.length; i++) {
          let SGST: any = 0.0;
          let CGST: any = 0.0;
          let IGST: any = 0.0;
          this.PrintData[i].TotalQty = 0;
          this.PrintData[i].TotalDiscount = 0;
          this.PrintData[i].TotalAmount = 0;
          this.PrintData[i].NetTotalAmount = 0;
          this.PrintData[i].RoundOffValue = 0;
          this.PrintData[i].TotalCGST = 0;
          this.PrintData[i].TotalSGST = 0;
          this.PrintData[i].TotalIGST = 0;
          let UBSrNo = 1;
          this.PrintData[i].InvoiceDetails.forEach((element) => {
            //-----for Ub only------------
            if (Type == "AllInOne") {
              if (element.Unit == "Day") {
                element.SrNo = UBSrNo;
                UBSrNo++;
              }
            }
            //----------------------------
            if (
              element.Discount == null ||
              element.Discount == undefined ||
              element.Discount == ""
            ) {
              element.Discount = 0;
            }
            if (this.PrintData[i].IsTaxable == true) {
              if (element.CGST != null && element.CGST != 0) {
                CGST = element.Amount * (element.CGST / 100);
              }
              if (element.SGST != null && element.SGST != 0) {
                SGST = element.Amount * (element.SGST / 100);
              }
              if (element.IGST != null && element.IGST != 0) {
                IGST = element.Amount * (element.IGST / 100);
              }
            } else {
              element.ChargedGST = "NA";
            }
            this.PrintData[i].TotalAmount += element.Amount;
            this.PrintData[i].TotalDiscount += element.Discount;
            this.PrintData[i].TotalQty += element.Quantity;
            this.PrintData[i].TotalQty = Math.round(this.PrintData[i].TotalQty * 100) / 100;
            this.PrintData[i].TotalCGST += parseFloat(CGST.toFixed(2));
            this.PrintData[i].TotalSGST += parseFloat(SGST.toFixed(2));
            this.PrintData[i].TotalIGST += parseFloat(IGST.toFixed(2));
            CGST = 0.0;
            SGST = 0.0;
            IGST = 0.0;
          });
          this.PrintData[i].TotalAmount = parseFloat(this.PrintData[i].TotalAmount.toFixed(2));
          this.PrintData[i].TotalCGST = parseFloat(this.PrintData[i].TotalCGST.toFixed(2));
          this.PrintData[i].TotalSGST = parseFloat(this.PrintData[i].TotalSGST.toFixed(2));
          this.PrintData[i].TotalIGST = parseFloat(this.PrintData[i].TotalIGST.toFixed(2));
          if (this.TaxApplicableFlag == true) {
            this.PrintData[i].NetTotalAmount = this.PrintData[i].TotalAmount + this.PrintData[i].TotalCGST + this.PrintData[i].TotalSGST + this.PrintData[i].TotalIGST;
          } else {
            this.PrintData[i].NetTotalAmount = this.PrintData[i].TotalAmount;
          }
          this.PrintData[i].NetTotalAmount = parseFloat(this.PrintData[i].NetTotalAmount.toFixed(2));
          if (this.hostUrl != 'https://ksh.ifreightbox.net/') {
            this.RoundOfAmount = parseFloat((Math.round(this.PrintData[i].NetTotalAmount) - this.PrintData[i].NetTotalAmount).toFixed(2));
            this.PrintData[i].NetTotalAmount = Math.round(this.PrintData[i].NetTotalAmount);
          }
          this.PrintData[i].RoundOffValue = this.RoundOfAmount;

          this.PrintData[i].TotalTaxablevalue = 0;
          this.PrintData[i].ComponentToTalIGST = 0;
          this.PrintData[i].ComponentToTalSGST = 0;
          this.PrintData[i].ComponentToTalCGST = 0;
          this.PrintData[i].ComponentToTalGST = 0;
          if (Type != "AllInOne") {
            this.PrintData[i].ComponentRate.forEach((element) => {
              element.ComponentGST = 0;
              if (this.PrintData[i].IsTaxable != true) {
                element.IntegratedGST = 0;
                element.StateGST = 0;
                element.CentralGST = 0;
                element.IGSTRATE = 0;
                element.SGSTRATE = 0;
                element.CGSTRATE = 0;
              }
              this.PrintData[i].TotalTaxablevalue += element.TaxableValue;
              this.PrintData[i].ComponentToTalIGST += element.IGSTRATE;
              this.PrintData[i].ComponentToTalSGST += element.SGSTRATE;
              this.PrintData[i].ComponentToTalCGST += element.CGSTRATE;
              element.ComponentGST += element.IGSTRATE + element.SGSTRATE + element.CGSTRATE;

              this.PrintData[i].TotalTaxablevalue = parseFloat((this.PrintData[i].TotalTaxablevalue).toFixed(2));
              this.PrintData[i].ComponentToTalIGST = parseFloat((this.PrintData[i].ComponentToTalIGST).toFixed(2));
              this.PrintData[i].ComponentToTalSGST = parseFloat((this.PrintData[i].ComponentToTalSGST).toFixed(2));
              this.PrintData[i].ComponentToTalCGST = parseFloat((this.PrintData[i].ComponentToTalCGST).toFixed(2));
            });
            this.PrintData[i].ComponentToTalGST = this.PrintData[i].ComponentToTalIGST + this.PrintData[i].ComponentToTalSGST + this.PrintData[i].ComponentToTalCGST;
          } else {
            this.PrintData[i].TotalDamage = 0;
            this.PrintData[i].TotalShortage = 0;
            this.PrintData[i].TotalSealShort = 0;
            this.PrintData[i].TotalGoodQtyBoxes = 0;
            this.PrintData[i].TotalGoodQtyBottles = 0;
            this.PrintData[i].InvoiceProductDetail.forEach((element) => {
              //--------------------Bottles---------------------
              let TotalBottles = element.Quantity * 12;
              let TotalGoodBottles = TotalBottles - (element.Damage + element.Shortage + element.SealShort);
              let TotalGoodQuantityBoxes: number = 0;
              TotalGoodQuantityBoxes = TotalGoodBottles % 12;
              element.TotalGoodQuantityBottles = TotalGoodQuantityBoxes;
              //--------------------Boxes-----------------------
              let DamageBoxes = Math.floor(TotalGoodBottles / 12);
              element.TotalGoodQuantityBoxes = DamageBoxes;
              //----------------------Total---------------------
              this.PrintData[i].TotalDamage = this.PrintData[i].TotalDamage + element.Damage;
              this.PrintData[i].TotalShortage = this.PrintData[i].TotalShortage + element.Shortage;
              this.PrintData[i].TotalSealShort = this.PrintData[i].TotalSealShort + element.SealShort;
              this.PrintData[i].TotalGoodQtyBoxes = this.PrintData[i].TotalGoodQtyBoxes + element.TotalGoodQuantityBoxes;
              this.PrintData[i].TotalGoodQtyBottles = this.PrintData[i].TotalGoodQtyBottles + element.TotalGoodQuantityBottles;
            });
          }
          if (Type == "AllInOne") {
            this.PrintData[i].TotalHaltingAmount = 0.0;
            this.PrintData[i].TotalProductQuantity = 0;
            this.PrintData[i].InvoiceDetails.forEach((element) => {
              if (element.Unit == "Day") {
                this.PrintData[i].TotalHaltingAmount =
                  this.PrintData[i].TotalHaltingAmount + element.Amount;
              }
            });
            this.PrintData[i].InvoiceProductDetail.forEach((element) => {
              this.PrintData[i].TotalProductQuantity = this.PrintData[i].TotalProductQuantity + element.Quantity
            });
          }
        }
        if (ToDo == "Print") {
          this.InvoiceTypeName = Type;
          this.PrintFormatsChild.InvoiceId = Id;
          this.PrintFormatsChild.PrintData = this.PrintData;
          this.PrintFormatsChild.InvoiceType = Type;
          $("#PrintInvoicePCN").val("");
          this.PrintFormatsChild.PrintInvoice();
        }
      },
        (err) => {
          this.toastr.error("An error occured printing !", "error");
        }
      );
    } else {
      this.isPrinting = true;
      this._appService.Post("Sales", "GetPrintData", this.PrintDataModal).subscribe((response) => {

        this.PrintData = response;
        this.cdr.detectChanges(); // 👈 force DOM update

        for (var i = 0; i < this.PrintData.length; i++) {

          let SGST: any = 0.0;

          let CGST: any = 0.0;

          let IGST: any = 0.0;



          this.PrintData[i].TotalQty = 0;

          this.PrintData[i].TotalDiscount = 0;

          this.PrintData[i].TotalAmount = 0;

          this.PrintData[i].NetTotalAmount = 0;

          this.PrintData[i].TotalCGST = 0;

          this.PrintData[i].TotalSGST = 0;

          this.PrintData[i].TotalIGST = 0;



          let UBSrNo = 1;



          this.PrintData[i].InvoiceDetails.forEach((element) => {

            //-----for Ub only------------

            if (Type == "AllInOne") {

              if (element.Unit == "Day") {

                element.SrNo = UBSrNo;

                UBSrNo++;

              }

            }

            //----------------------------

            if (

              element.Discount == null ||

              element.Discount == undefined ||

              element.Discount == ""

            ) {

              element.Discount = 0;

            }

            if (this.PrintData[i].IsTaxable == true) {

              if (element.CGST != null && element.CGST != 0) {

                CGST = element.Amount * (element.CGST / 100);

              }

              if (element.SGST != null && element.SGST != 0) {

                SGST = element.Amount * (element.SGST / 100);

              }

              if (element.IGST != null && element.IGST != 0) {

                IGST = element.Amount * (element.IGST / 100);

              }

            } else {

              element.ChargedGST = "NA";

            }



            this.PrintData[i].TotalAmount += element.Amount;

            this.PrintData[i].TotalDiscount += element.Discount;

            this.PrintData[i].TotalQty += element.Quantity;

            this.PrintData[i].TotalQty =

              Math.round(this.PrintData[i].TotalQty * 100) / 100;



            this.PrintData[i].TotalCGST += parseFloat(CGST.toFixed(2));

            this.PrintData[i].TotalSGST += parseFloat(SGST.toFixed(2));

            this.PrintData[i].TotalIGST += parseFloat(IGST.toFixed(2));

            CGST = 0.0;

            SGST = 0.0;

            IGST = 0.0;

            // if (this.PrintData[i].ChargeType == 'Credit Note') {

            //   element.Amount = element.Amount * -1;

            // }

          });



          this.PrintData[i].TotalAmount = parseFloat(this.PrintData[i].TotalAmount.toFixed(2));

          this.PrintData[i].TotalCGST = parseFloat(this.PrintData[i].TotalCGST.toFixed(2));

          this.PrintData[i].TotalSGST = parseFloat(this.PrintData[i].TotalSGST.toFixed(2));

          this.PrintData[i].TotalIGST = parseFloat(this.PrintData[i].TotalIGST.toFixed(2));

          this.PrintData[i].NetTotalAmount =

            this.PrintData[i].TotalAmount +

            this.PrintData[i].TotalCGST +

            this.PrintData[i].TotalSGST +

            this.PrintData[i].TotalIGST;

          this.PrintData[i].NetTotalAmount = parseFloat(this.PrintData[i].NetTotalAmount.toFixed(2));



          this.PrintData[i].TotalTaxablevalue = 0;

          this.PrintData[i].ComponentToTalIGST = 0;

          this.PrintData[i].ComponentToTalSGST = 0;

          this.PrintData[i].ComponentToTalCGST = 0;

          this.PrintData[i].ComponentToTalGST = 0;

          if (Type != "AllInOne") {

            this.PrintData[i].ComponentRate.forEach((element) => {

              element.ComponentGST = 0;

              if (this.PrintData[i].IsTaxable != true) {

                element.IntegratedGST = 0;

                element.StateGST = 0;

                element.CentralGST = 0;

                element.IGSTRATE = 0;

                element.SGSTRATE = 0;

                element.CGSTRATE = 0;

              }

              this.PrintData[i].TotalTaxablevalue += element.TaxableValue;

              this.PrintData[i].ComponentToTalIGST += element.IGSTRATE;

              this.PrintData[i].ComponentToTalSGST += element.SGSTRATE;

              this.PrintData[i].ComponentToTalCGST += element.CGSTRATE;

              element.ComponentGST +=

                element.IGSTRATE + element.SGSTRATE + element.CGSTRATE;


              this.PrintData[i].TotalTaxablevalue = parseFloat((this.PrintData[i].TotalTaxablevalue).toFixed(2));
              this.PrintData[i].ComponentToTalIGST = parseFloat((this.PrintData[i].ComponentToTalIGST).toFixed(2));
              this.PrintData[i].ComponentToTalSGST = parseFloat((this.PrintData[i].ComponentToTalSGST).toFixed(2));
              this.PrintData[i].ComponentToTalCGST = parseFloat((this.PrintData[i].ComponentToTalCGST).toFixed(2));
              // end

            });

            this.PrintData[i].ComponentToTalGST =

              parseFloat((this.PrintData[i].ComponentToTalIGST +

                this.PrintData[i].ComponentToTalSGST +

                this.PrintData[i].ComponentToTalCGST).toFixed(2));

          } else {

            this.PrintData[i].TotalDamage = 0;

            this.PrintData[i].TotalShortage = 0;

            this.PrintData[i].TotalSealShort = 0;

            this.PrintData[i].TotalGoodQtyBoxes = 0;

            this.PrintData[i].TotalGoodQtyBottles = 0;



            this.PrintData[i].InvoiceProductDetail.forEach((element) => {

              //--------------------Bottles---------------------

              let TotalBottles = element.Quantity * 12;

              let TotalGoodBottles =

                TotalBottles -

                (element.Damage + element.Shortage + element.SealShort);

              let TotalGoodQuantityBoxes: number = 0;

              TotalGoodQuantityBoxes = TotalGoodBottles % 12;

              element.TotalGoodQuantityBottles = TotalGoodQuantityBoxes;

              //--------------------Boxes-----------------------

              let DamageBoxes = Math.floor(TotalGoodBottles / 12);

              element.TotalGoodQuantityBoxes = DamageBoxes;

              //----------------------Total---------------------



              this.PrintData[i].TotalDamage =

                this.PrintData[i].TotalDamage + element.Damage;

              this.PrintData[i].TotalShortage =

                this.PrintData[i].TotalShortage + element.Shortage;

              this.PrintData[i].TotalSealShort =

                this.PrintData[i].TotalSealShort + element.SealShort;

              this.PrintData[i].TotalGoodQtyBoxes =

                this.PrintData[i].TotalGoodQtyBoxes + element.TotalGoodQuantityBoxes;

              this.PrintData[i].TotalGoodQtyBottles =

                this.PrintData[i].TotalGoodQtyBottles +

                element.TotalGoodQuantityBottles;

            });

          }

          if (Type == "AllInOne") {

            this.PrintData[i].TotalHaltingAmount = 0.0;

            this.PrintData[i].TotalProductQuantity = 0;

            this.PrintData[i].InvoiceDetails.forEach((element) => {

              if (element.Unit == "Day") {

                this.PrintData[i].TotalHaltingAmount =

                  this.PrintData[i].TotalHaltingAmount + element.Amount;

              }

            });

            this.PrintData[i].InvoiceProductDetail.forEach((element) => {

              this.PrintData[i].TotalProductQuantity =

                this.PrintData[i].TotalProductQuantity + element.Quantity;

            });

          }

        }

        setTimeout(() => {
          if (ToDo == "Print") {
            // console.log('inside ToDo == "Print"',this.PrintData);
            this.InvoiceTypeName = Type;
            this.PrintFormatsChild.InvoiceId = Id;
            this.PrintFormatsChild.PrintData = this.PrintData;
            this.PrintFormatsChild.InvoiceType = Type;
            this.PrintFormatsChild.PrintInvoice();
            this.isPrinting = false;

            console.log('inside GetPrintData func else block',this.PrintData);
          }
        }, 1500);
      },

        (err) => {

          this.toastr.error(err._body.replace(/"/g, ""), "error");

        }

      );
    }

  }

  GetInvoiceById() {
    this._appService.GetById("Sales", "NewGetInvoiceById", this.InvoiceId).subscribe(response => {
      if (response.Table.length > 0) {
        this.data = response.Table[0];
        this.data.Id = response.Table[0].Id;
      }
      if (response.Table1.length > 0) {
        this.data.Products = response.Table1;
      }

      // setTimeout(() => {
      //   this.CalculateGSTForAll();
      // }, 500);
    },
      (err) => {
        this.toastr.error("Error While Getting Edit data", err);
      }
    );
  }

  Generate_EInvoice(Id) {
    Helpers.setLoading(true);
    $("#Btn_eInvoice").prop("disabled", true);
    this._appService
      .GetByThreeId(
        "Sales",
        "inv_GetDataForEInvoiceData",
        Id,
        this.CompanyId,
        this.userId
      )
      .subscribe(
        (response) => {
          if (response.responceMes == "OK") {
            this.toastr.success("Successfully generate e-invoice", "Success");
            this.data.IsEInvoiceDone = true;
            this.data.IRNNumber = response.IRNNo;
            this.data.EinvoicePdfLink = response.EInvoicePDF;
            $("#Btn_cancle_eInvoice").prop("disabled", false);
          } else {
            $("#Btn_eInvoice").prop("disabled", false);
            this.toastr.error(response.responceMes, "Error");
          }
          Helpers.setLoading(false);
        },
        (err) => {
          Helpers.setLoading(false);
          $("#Btn_eInvoice").prop("disabled", false);
          this.toastr.error(err._body.replace(/"/g, ""), "Error");
        }
      );
  }

  // modalRef: any;
  @ViewChild('CancelEInvoice') CancelEInvoice: TemplateRef<any>;
  CancelReasonName: any;
  open_cancleEInvoiceMode() {
    this.modalRef = this.modalService.open(this.CancelEInvoice, {
      centered: true,
      size: 'lg'
    });
  }

  GetCancelReason(value, isScrollDown = false) {
    this.CancelReason.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.CancelReason.dropdownList.length / 20) + 1;
    }
    this._appService.GetByQueryPageForReason('ReasonMaster', 'GetSelect2ReasonList', value, pageNo, 'Order').subscribe(res => {
      res.Results.map(x => {
        x.name = x.text;
        x.value = x.id;
      })
      let dropdownList = [...res.Results];
      if (isScrollDown && res.Total > this.CancelReason.dropdownList.length) {
        dropdownList = dropdownList.concat(this.CancelReason.dropdownList);
        this.CancelReason = { ...this.CancelReason, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.CancelReason = { ...this.CancelReason, dropdownList: [...dropdownList] });
      this.CancelReason.isSearch = false;
    }),
      (error => {
        this.CancelReason.isSearch = false;
      })
  }

  Cancle_EInvoice() {
    if (!this.CancelReasonName) {
      this.toastr.error('Please select reason', 'Error');
      return;
    }

    Helpers.setLoading(true);
    this._appService
      .GetByThreeId(
        "Sales",
        "inv_CancleEInvoiceData",
        this.InvoiceId,
        this.CompanyId,
        this.CancelReasonName
      )
      .subscribe(
        (response) => {
          if (response.responceMes == "OK") {
            this.toastr.success("Successfully cancle e-invoice", "Success");
            this.data.IsEInvoiceDone = false;
          } else {
            this.toastr.error(response.responceMes, "Error");
          }
          Helpers.setLoading(false);
        },
        (err) => {
          Helpers.setLoading(false);
          this.toastr.error(err._body.replace(/"/g, ""), "Error");
        }
      );
  }

  getChangedValue(value, data, isEdit = false) {
    const newValue = value && typeof value === 'object' && 'value' in value ? value.value : value;
    if (data.dataField == 'CancelReason') {
      this.CancelReasonName = newValue;
    } else if (data.dataField == 'ConsignmentNo') {
      this.findLR[data.dataField] = newValue;
      this.GetInv_statusbyconsignment(value.name);
    }
  }

  @ViewChild('SendMail') SendMail: TemplateRef<any>;
  OpenSendMail() {
    this.modalRef = this.modalService.open(this.SendMail, {
      centered: true,
      size: 'lg',
      windowClass: 'modal-xl-custom'
    });
  }

  closeModal(event: any) {
    this.modalRef.close();
  }

  DeleteInvoiceById() {
    return new Promise((resolve) => {
      const dialogRef = this.modalService.open(ConfirmationPopupComponent, { centered: true });
      dialogRef.componentInstance.details = {
        message: 'Are you sure you want to delete this order?',
        title: 'Confirmation',
      }
      dialogRef.componentInstance.close.subscribe((res: any) => {
        if (res) {
          Helpers.setLoading(true);
          this._appService.Delete("Sales", "DeleteInvoiceById", this.InvoiceId).subscribe((response) => {
            Helpers.setLoading(false);
            this.SaveDeletedTransactionHistory(this.InvoiceId);
            this.BackToList();
            this.toastr.success("Successfully Deleted !", "Success");
          },
            (err) => {
              Helpers.setLoading(false);
              this.toastr.error("An error occured while deleting data !", "error");
            }
          );
        }
        dialogRef.close();
      });
    });
  }

  BackToList() {
    if (this.type == 'SalesInvoice') {
      if (this.isFormPendingInvoicePage) {
        this.router.navigateByUrl(`/pending-invoice-consignment`);
      } else {
        this.router.navigateByUrl(`/sales-invoice-new`);
      }
    } else if (this.type == 'PaymentReceipt') {
      this.router.navigateByUrl(`/new-payment-received`);
    }
    //added by burhan - 13-Feb-2026
    else if(this.type == 'PurchaseBill'){
      this.router.navigateByUrl(`/purchase-bills`)
    }
    else if (this.type == 'PaymentMade'){
      this.router.navigateByUrl(`/new-payment-made`);
    }
    //ended by BURHAN - 13-Feb-2026
     else if (this.type == 'TollPlaza') {
      this.router.navigateByUrl(`/TollPlaza`);
    }
     else if (this.type == 'JournalEntry') { //added by fahim 02-03-2026
      this.router.navigateByUrl(`/new-journal-entry`);
    }
    this.onRefreshList.emit('true')
  }

  SaveDeletedTransactionHistory(Id) {
    var obj: any = {};
    obj.TransactionId = Id;
    obj.TransactionType = 'Sales';
    obj.UserId = this.userId;
    this._appService.Post("Common", "SaveDelTransactionHistory", obj).subscribe((response) => {
    },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );
  }

  @ViewChild('sendMailRef') sendMailComponent: SendMailComponent;
  onSendEmail() {
    this.modalRef.componentInstance.sendEmail();
  }

  @ViewChild('LRStatus') LRStatus: TemplateRef<any>;
  OpenLRStatusModal() {
    this.modalRef = this.modalService.open(this.LRStatus, { centered: true, size: "lg", windowClass: "modal-xl-custom" });
  }

  getLRConsignmentList(value, isScrollDown = false) {
    this.ConsignmentNo.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.ConsignmentNo.dropdownList.length / 20) + 1;
    }
    this._appService.GetByQueryPageCompanyId('Sales', 'inv_Consigmeentstatus', value, pageNo, this.CompanyId).subscribe(res => {
      res.Results.map(x => {
        x.name = x.text;
        x.value = x.id;
      })
      let dropdownList = [...res.Results];
      if (isScrollDown && res.Total > this.ConsignmentNo.dropdownList.length) {
        dropdownList = dropdownList.concat(this.ConsignmentNo.dropdownList);
        this.ConsignmentNo = { ...this.ConsignmentNo, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.ConsignmentNo = { ...this.ConsignmentNo, dropdownList: [...dropdownList] });
      this.ConsignmentNo.isSearch = false;
    }),
      (error => {
        this.ConsignmentNo.isSearch = false;
      })
  }

  statusbyconsignment: any = [];
  GetInv_statusbyconsignment(TripQuery) {
    this._appService
      .GetByTwoId(
        "Sales",
        "GetInv_statusbyconsignment",
        TripQuery,
        this.CompanyId
      )
      .subscribe(
        (response) => {
          this.statusbyconsignment = response;
        },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "Error");
        }
      );
    Helpers.setLoading(false);
  }

  // Added by priya - 29/12/2025
  GetBillPaymentById() {
    // Added condition by priya - 06/01/2026 - in add page invoice id is getting 'null' so api is throwing error
    if (this.InvoiceId !== 'null') {
      this._appService.GetById("BillPayment", "GetBillPaymentById", this.InvoiceId).subscribe(response => {
        this.data = response;
        this.data.Id = response.Id;
        this.data.VendorId = response.VendorId;
        this.data.Products = response.PaymentDetails;
      },
        (err) => {
          this.toastr.error("Error While Getting Edit data", err);
        }
      );
    }
  }
  //added by burhan - 11-Feb-2026
  DeleteCashExpenseById() {
    return new Promise((resolve) => {
      const dialogRef = this.modalService.open(ConfirmationPopupComponent, { centered: true });
      dialogRef.componentInstance.details = {
        message: 'Are you sure you want to delete this Cash Expense?',
        title: 'Confirmation',
      }
      dialogRef.componentInstance.close.subscribe((res: any) => {
        if (res) {
          Helpers.setLoading(true);
          this._appService.Delete("Expense", "DeleteExpenseById", this.data.Id).subscribe((response) => {
            Helpers.setLoading(false);
            this.toastr.success("Expense detail deleted successfully", "success");
            //this.GetExpenseList();
          },
            (err) => {
              this.toastr.error(err._body.replace(/"/g, ""), "error");
              Helpers.setLoading(false);
            }
          );
        }
        dialogRef.close();
      });
    })
  }


  DeleteCashReceiptById() {
    return new Promise((resolve) => {
      const dialogRef = this.modalService.open(ConfirmationPopupComponent, { centered: true });
      dialogRef.componentInstance.details = {
        message: 'Are you sure you want to delete this Cash Receipt?',
        title: 'Confirmation',
      }
      dialogRef.componentInstance.close.subscribe((res: any) => {
        if (res) {
          Helpers.setLoading(true);
          this._appService.Delete("Expense", "DeleteCashReceiptById", this.data.Id).subscribe((response) => {
            Helpers.setLoading(false);
            this.toastr.success("Expense detail deleted successfully", "success");
            //this.GetExpenseList();
          },
            (err) => {
              this.toastr.error(err._body.replace(/"/g, ""), "error");
              Helpers.setLoading(false);
            }
          );
        }
        dialogRef.close();
      });
    })
  }
  //ended by burhan - 11-Feb-2026

  DeleteBillPaymentById() {
    return new Promise((resolve) => {
      const dialogRef = this.modalService.open(ConfirmationPopupComponent, { centered: true });
      dialogRef.componentInstance.details = {
        message: 'Are you sure you want to delete this payment?',
        title: 'Confirmation',
      }
      dialogRef.componentInstance.close.subscribe((res: any) => {
        if (res) {
          Helpers.setLoading(true);
          this._appService.Delete("BillPayment", "DeleteBillPaymentById", this.InvoiceId).subscribe((response) => {
            Helpers.setLoading(false);
            this.BackToList();
            this.toastr.success("Successfully Deleted !", "Success");
          },
            (err) => {
              Helpers.setLoading(false);
              this.toastr.error("An error occured while deleting data !", "error");
            }
          );
        }
        dialogRef.close();
      });
    });
  }

  GetPaymentMadePrints(Id, VendorId, Type) {
    if (Type == 'PrintPaymentAdvice') {
      this._appService.GetByTwoId("BillPayment", "GetPrintData", Id, VendorId).subscribe((response) => {
        var obj: any = {}
        this.PrintData = [];
        obj.PrintPaymentHeaderObj = response.BillPaymentPrintViewMode || {};
        obj.PrintPaymentDetails = response.BillPaymentDetailPrintViewModel || [];
        this.PrintData = [obj];

        this.InvoiceTypeName = Type;
        this.PrintFormatsChild.CompId = this.CompanyId;
        this.PrintFormatsChild.InvoiceId = Id;
        this.PrintFormatsChild.PrintData = this.PrintData;
        this.PrintFormatsChild.InvoiceType = Type;
        this.PrintFormatsChild.PrintPaymentAdvice();
        Helpers.setLoading(false);
      },
    (error) =>{
      Helpers.setLoading(false);
      this.toastr.error("Error While Getting Print Data", error);
    }
    );
    } else if (Type == 'PrintDetailPaymentAdvice') {
      this._appService.GetByTwoId("BillPayment", "GetPrintDetailData", Id, VendorId).subscribe((response) => {
        var obj: any = {}
        this.PrintData = [];
        obj.PrintDetailPaymentHeaderObj = response.BillPaymentDetailPrintViewMode || {};
        obj.PrinDetailPaymentDetails = response.BillPaymentDetailDetailPrintViewModel || [];
        this.PrintData = [obj];

        this.InvoiceTypeName = Type;
        this.PrintFormatsChild.CompId = this.CompanyId;
        this.PrintFormatsChild.InvoiceId = Id;
        this.PrintFormatsChild.PrintData = this.PrintData;
        this.PrintFormatsChild.InvoiceType = Type;
        this.PrintFormatsChild.PrintDetailPaymentAdvice();
        Helpers.setLoading(false);
      }, (error) => {

        Helpers.setLoading(false);
        this.toastr.error("Error While Getting Print Detail Data", error);
      });
    }
  }
  // End by priya

  //added by BURHAN - 12-Feb-2026
  DeleteReceipt() {
    //
    return new Promise((resolve) => {
      const dialogRef = this.modalService.open(ConfirmationPopupComponent, { centered: true });
      dialogRef.componentInstance.details = {
        message: 'Are you sure you want to delete this receipt?',
        title: 'Confirmation',
      }
      dialogRef.componentInstance.close.subscribe((res: any) => {
        if (res) {
          Helpers.setLoading(true);
          this._appService.Delete("Sales", "DeletePaymentReceiptById", this.InvoiceId).subscribe((response) => {
            Helpers.setLoading(false);
            this.BackToList();
            this.toastr.success("Successfully Deleted !", "Success");
          },
            (err) => {
              Helpers.setLoading(false);
              this.toastr.error("An error occured while deleting data !", "error");
            }
          );
        }
        dialogRef.close();
      });
    });
  }
  //end by BURHAN - 12-Feb-2026
  //add by BURHAN - 13-Feb-2026
  BillDelete() {
    return new Promise((resolve) => {
      const dialogRef = this.modalService.open(ConfirmationPopupComponent, { centered: true });
      dialogRef.componentInstance.details = {
        message: 'Are you sure you want to delete this Bill?',
        title: 'Confirmation',
      }
      dialogRef.componentInstance.close.subscribe((res: any) => {
        if (res) {
          Helpers.setLoading(true);
          this._appService.Delete("Bills", "DeleteBills", this.InvoiceId).subscribe((response) => {
            Helpers.setLoading(false);
            this.toastr.success("Bill deleted successfully", "success");
            this.BackToList();
          },
            (err) => {
              this.toastr.error(err._body.replace(/"/g, ""), "error");
              Helpers.setLoading(false);
            }
          );
        }
        dialogRef.close();
      });
    })
  }
  //add by BURHAN - 13-Feb-2026

  //added by fahim 31-12-2025
  onCancelClick(type) {
    return new Promise((resolve) => {
      const dialogRef = this.modalService.open(ConfirmationPopupComponent, { centered: true });
      dialogRef.componentInstance.details = {
        message: `Are you sure you want to cancel this ${type}?`,
        title: 'Confirmation',
        action: 'Yes, Cancel it!'
      }
      dialogRef.componentInstance.close.subscribe((res: any) => {
        if (res) {
          this.modalRef = this.modalService.open(this.contactFromTemplate, { centered: true, size: "lg" });
        }
        dialogRef.close();
      });
    })
  }

  onRefreshParent(event){
    this.onRefreshList.emit(event);
  }

  // Added by priya - 10/01/2026 - print trip profibility - CN - PRIYA-JAN26-008
  PrintTripProfibility(OrderId, BookingId) {
    this.PrintFormatsNewComponent.OrderId = OrderId;
    this.PrintFormatsNewComponent.BookingId = BookingId;
    this.PrintFormatsNewComponent.UserId = this.userId;
    this.PrintFormatsNewComponent.CompanyId = this.CompanyId;
    this.PrintFormatsNewComponent.PrintTripProfibility();
  }

  // Added by priya - 13/01/2026 - Delete toll plaza - CN(PRIYA-JAN26-010)
  DeleteTollPlazaById() {
    return new Promise((resolve) => {
      const dialogRef = this.modalService.open(ConfirmationPopupComponent, { centered: true });
      dialogRef.componentInstance.details = {
        message: 'Are you sure you want to delete this data?',
        title: 'Confirmation',
      }
      dialogRef.componentInstance.close.subscribe((res: any) => {
        if (res) {
          Helpers.setLoading(true);
          this._appService.GetById("VehicleMaster", "DeleteTollPlaza", this.InvoiceId).subscribe((response) => {
            Helpers.setLoading(false);
            this.BackToList();
            this.toastr.success("Successfully Deleted !", "Success");
          },
            (err) => {
              Helpers.setLoading(false);
              this.toastr.error("An error occured while deleting data !", "error");
            }
          );
        }
        dialogRef.close();
      });
    });
  }

  // Added by priya - 28/01/2026 - Eway bill log modal - cn(PRIYA-JAN26-014)
  @ViewChild('EwayBillLogComponent') EwayBillLogComponent: EwayBillLogComponent;
  OpenEwayBillLogModal() {
    this.modalRef = this.modalService.open(this.EwayBillLogComponent, { centered: true, size: "lg", windowClass: "modal-xl-custom" });
  }

  //Added by fahim 03-02-2026 :)
  openAddOrdersModal() {
    this.modalRef = this.modalService.open(this.AddOrders, { centered: true, size: "lg", windowClass: "modal-md-custom-addorders"});
  }

  // Added by priya - 09/02/2026 - Getting eway lr data - cn(PRIYA-JAN26-017)
  GetEwayLrData(BookingId, ConsignmentDetailId) {
    this.Eway.GetEwayLrData(BookingId, ConsignmentDetailId).then(data => {
      this.EwayConsignmentList = data;
    })
    .catch(err => {
      console.error(err);
    });
  }

  // Added by priya - 09/02/2026 - Generate Part B for Eway bill - cn(PRIYA-JAN26-017)
  GeneratePartB(BookingId, ConsignmentDetailId){
    return new Promise((resolve) => {
      const dialogRef = this.modalService.open(ConfirmationPopupComponent, { centered: true });
      dialogRef.componentInstance.details = {
        message: 'Are you sure you want to Generate Part B for this eway bill?',
        title: 'Confirmation',
        action: 'Yes, File It!'
      }
      dialogRef.componentInstance.close.subscribe((res: any) => {
        if (res) {
          this.Eway.GenerateEwayPartB(this.EwayConsignmentList, this.userId, BookingId, ConsignmentDetailId).then(res => {
            if (res.success) {
              this.toastr.success('PartB Generated Successfully!');
              resolve(true);
            } else {
              this.toastr.warning(res.errorMessage);
              resolve(false);
            }
          }).catch(err => {
            this.toastr.error(err);
            resolve(false);
          });
        }
        dialogRef.close();
      });
    });
  }

  // Added by priya - 09/02/2026 - Print Eway bill - cn(PRIYA-JAN26-017)
  PrintEwayBill(ConsignmentDetailId, EwayBillNo){
    this.Eway.GetVerifiedEwayBillData(ConsignmentDetailId, EwayBillNo).then(data => {
      if (data) {
        let EwayData: any = data;
        setTimeout(() => {
          if (EwayData && EwayData.length > 0) {
            EwayData.forEach((item) => {
              if (item.eWayBillDocUrl !== null) {
                window.open(item.eWayBillDocUrl, "_blank");
              } else {
                this.toastr.warning('Eway bill url is not available')
              }
            });
          }
        }, 300);
      }
    })
    .catch(err => {
      console.error(err);
    });
  }

  // Added by priya - 09/02/2026 - Change Transporter Vehicle and driver modal - cn(PRIYA-JAN26-014)
  @ViewChild('ChangeTransVehDriverComponent') ChangeTransVehDriverComponent: ChangeTransVehDriverComponent;
  OpenChangeTransVehDriModal() {
    this.modalRef = this.modalService.open(this.ChangeTransVehDriverComponent, { centered: true, size: "lg" });
  }

  // Added by priya - 10/02/2026 - Extend Eway bill modal - cn(PRIYA-JAN26-014)
  @ViewChild('ExtendEwayBillComponent') ExtendEwayBillComponent: ExtendEwayBillComponent;
  OpenExtendEwayBillModal() {
    this.modalRef = this.modalService.open(this.ExtendEwayBillComponent, { centered: true, size: "lg" });
  }

  //added by BURHAN - 12-Feb-2026
  GetExpenseById() {
    if (this.InvoiceId !== 'null') {
      this._appService.GetById("Expense", "GetExpenseById", this.InvoiceId).subscribe(response => {
        this.data = response;
        this.data.Id = response.Id;
        // this.data.VendorId = response.VendorId;
        // this.data.Products = response.PaymentDetails;
      },
        (err) => {
          this.toastr.error("Error While Getting Edit data", err);
        }
      );
    }
  }

  GetCashReceiptById() {
    // Added condition by priya - 06/01/2026 - in add page invoice id is getting 'null' so api is throwing error
    if (this.InvoiceId !== 'null') {
      this._appService.GetById("Expense", "NewGetCashReceiptList", this.InvoiceId).subscribe(response => {
        this.data = response;
        this.data.Id = response.Id;
        // this.data.VendorId = response.VendorId;
        // this.data.Products = response.PaymentDetails;
      },
        (err) => {
          this.toastr.error("Error While Getting Edit data", err);
        }
      );
    }
  }

  //ended by BURHAN - 12-Feb-2026

  // Added by priya - 10/01/2026 - print expense voucher - CN(PRIYA-FEB26-003)
  PrintExpenseVoucher(BookingId, UserId){
    this.PrintFormatsNewComponent.BookingId = BookingId;
    this.PrintFormatsNewComponent.UserId = this.userId;
    this.PrintFormatsNewComponent.CompanyId = this.CompanyId;
    this.PrintFormatsNewComponent.ExpenseVoucherData = [];
    this.PrintFormatsNewComponent.printExpenseVoucher();
  }

  // Added by priya - 13/01/2026 - go to advance payment screen for Make payment - CN(PRIYA-FEB26-003)
  MakePayment(){
    localStorage.setItem('PaymentRequestData', JSON.stringify(this.data))
    localStorage.setItem('FromPage', 'PaymentRequest')
    setTimeout(() => {
      this.router.navigateByUrl(`/new-payment-made/edit/null`);
    }, 500);
  }

  // Added by priya - 18/02/2026 - cn(PRIYA-FEB26-004)
  @ViewChild(PrintReportComponent) PrintReportChild: PrintReportComponent;
  PrintPurchaseBillDetails(Type: any) {
    if (Type == 'Detail') {
      this.PrintFormatsNewComponent.CompanyId = this.CompanyId;
      this.PrintFormatsNewComponent.BillId = this.data.Id;
      this.PrintFormatsNewComponent.ReportType = 'Detail';
      this.PrintFormatsNewComponent.GetPrintBillData();
    }
  }

  // Added by priya - 23/02/2026 - cn(PRIYA-FEB26-004)
  // GetPurchaseBillById() {
  //   if (this.InvoiceId !== 'null') {
  //     this._appService.GetById("Bills", "GetBillsById", this.InvoiceId).subscribe(response => {
  //       this.data = response;
  //       this.data.Id = response.Id;
  //       this.data.VendorId = response.VendorId || response.DriverId || response.Vendor;
  //       this.data.Products = response.BillsDetails;
  //     },
  //       (err) => {
  //         this.toastr.error("Error While Getting Edit data", err);
  //       }
  //     );
  //   }
  // }

  //added by burhan - 14-Feb-2026
  PrintExpenseVoucher2(ExpenseId, UserId) {

    this.PrintFormatsNewComponent.ExpenseId = this.data.Id;
    this.PrintFormatsNewComponent.UserId = this.userId;
    this.PrintFormatsNewComponent.CompanyId = this.CompanyId;
    this.PrintFormatsNewComponent.printExpVoucher2();

  }
  //ended by burhan - 14-Feb-2026

  //added by burhan - 19-Feb-2026
  PrintPaymentReceiptVoucher(ExpenseId, UserId) {

    this.PrintFormatsNewComponent.InvoiceId = this.InvoiceId;
    this.PrintFormatsNewComponent.UserId = this.userId;
    this.PrintFormatsNewComponent.CompanyId = this.CompanyId;
    this.PrintFormatsNewComponent.printExpVoucher2();

  }
  //ended by burhan - 19-Feb-2026
  //added by burhan - 23-Feb-2026
  PrintPaymentReceiptVoucher2(Id){
    this.PrintFormatsNewComponent.InvoiceId = Id;
    this.PrintFormatsNewComponent.UserId = this.userId;
    this.PrintFormatsNewComponent.CompanyId = this.CompanyId;
    this.PrintFormatsNewComponent.PrintPaymentReceiptVoucher();
  }

  PrintPaymentDetails(Id){
    this.PrintFormatsNewComponent.InvoiceId = Id;
    this.PrintFormatsNewComponent.UserId = this.userId;
    this.PrintFormatsNewComponent.CompanyId = this.CompanyId;
    this.PrintFormatsNewComponent.PrintPaymentMadeVoucher();
  }
  
  deleteJVData(Id) { //added by fahim 02-03-2026
    return new Promise((resolve) => {
      const dialogRef = this.modalService.open(ConfirmationPopupComponent, { centered: true });
      dialogRef.componentInstance.details = {
        message: 'Are you sure you want to delete this?',
        title: 'Confirmation',
      }
      dialogRef.componentInstance.close.subscribe((res: any) => {
        if (res) {
          Helpers.setLoading(true);
          this._appService.Delete("JournalEntry", "DeleteJournalEntry", Id).subscribe((response) => {
            Helpers.setLoading(false);
            this.BackToList();
            this.toastr.success("Successfully Deleted !", "Success");
          },
            (err) => {
              Helpers.setLoading(false);
              this.toastr.error("An error occured while deleting data !", "error");
            }
          );
        }
        dialogRef.close();
      });
    });
  }

  PrintJournalEntry(Id){
    this.PrintFormatsNewComponent.OrderId = Id;
    this.PrintFormatsNewComponent.UserId = this.userId;
    this.PrintFormatsNewComponent.CompanyId = this.CompanyId;
    this.PrintFormatsNewComponent.NewPrintPaymentVoucher();
  }

  // Added by priya - 02/04/2026 - cn(PRIYA-APR26-001)
  @ViewChild('DriverConsentComponent') DriverConsentComponent: DriverConsentComponent;
  OpenDriverConsentModal(){
    this.modalRef = this.modalService.open(this.DriverConsentComponent, { centered: true, size: "lg", windowClass: "modal-consent" });
  }

  DeleteGateData(id) {
    if (!id) {
      return;
    }
    const dialogRef = this.modalService.open(ConfirmationPopupComponent, {
      centered: true,
    });
    dialogRef.componentInstance.details = {
      message: "Are you sure you want to delete this gate management record?",
      title: "Confirmation",
    };
    dialogRef.componentInstance.close.subscribe((res: any) => {
      if (res) {
        Helpers.setLoading(true);
        this._appService.GetByTwoId("so_GoodsOutward", "DeleteGateData", this.userId, id).subscribe(
          (response) => {
            Helpers.setLoading(false);
            this.toastr.success("Data deleted successfully", "success");
            this.BackToList();
          },
          (err) => {
            Helpers.setLoading(false);
            this.toastr.error(err._body ? err._body.replace(/"/g, "") : "Delete failed", "error");
          }
        );
      }
      dialogRef.close();
    });
  }

  PrintGatePass(id: any) {
    if (!id) {
      return;
    }
    Helpers.setLoading(true);
    this._appService.GetByTwoId("so_GoodsOutward", "GateManagementById", id, this.CompanyId).subscribe(
      (response) => {
        const gatePassData = response && response.length ? response[0] : {};
        // if (!this.PrintFormatsNewComponent) {
        //   Helpers.setLoading(false);
        //   this.toastr.error("Print format is not ready", "error");
        //   return;
        // }
        setTimeout(() => {
          this.PrintFormatsNewComponent.PrintGatePass(gatePassData);
        }, 300);
      },
      (err) => {
        Helpers.setLoading(false);
        this.toastr.error(err && err._body ? err._body.replace(/"/g, "") : "Print failed", "error");
      }
    );
  }

  MarkAsGateOut(id: any) {
    if (!id) {
      return;
    }
    Helpers.setLoading(true);
    const gateOutTime = encodeURIComponent(new Date().toISOString());
    this._appService.GetByThreeId("so_GoodsOutward", "MarkGateOut", this.userId, id, gateOutTime).subscribe(
      () => {
        Helpers.setLoading(false);
        this.toastr.success("Gate out marked successfully", "success");
        // this.GetDataList();
      },
      (err) => {
        Helpers.setLoading(false);
        this.toastr.error(err && err._body ? err._body.replace(/"/g, "") : "Gate out update failed", "error");
      }
    );
  }

}
